// :: START :: Product Gallery v1, v2, v3

function updateCliniciansChoiceSticker(galleryElement, slideIndex) {
  var $section = $(galleryElement).closest('.main__product_page');
  var $sticker = $section
    .find('[data-clinicians-choice-sticker]')
    .first();

  if (!$sticker.length) return;

  var isFirstSlide = Number(slideIndex) === 0;

  $sticker.toggleClass('is-hidden', !isFirstSlide);
  $sticker.attr(
    'aria-hidden',
    isFirstSlide ? 'false' : 'true'
  );
}

$('.product-gallery-single')
  .on(
    'init.cliniciansChoiceSticker reInit.cliniciansChoiceSticker',
    function (event, slick) {
      updateCliniciansChoiceSticker(
        this,
        slick && typeof slick.currentSlide !== 'undefined'
          ? slick.currentSlide
          : 0
      );
    }
  )
  .on(
    'beforeChange.cliniciansChoiceSticker',
    function (event, slick, currentSlide, nextSlide) {
      updateCliniciansChoiceSticker(
        this,
        nextSlide
      );
    }
  )
  .on(
    'afterChange.cliniciansChoiceSticker',
    function (event, slick, currentSlide) {
      updateCliniciansChoiceSticker(
        this,
        currentSlide
      );
    }
  )
  .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    asNavFor: '.product-gallery-thumbnails'
  });

$('.product-gallery-thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-gallery-single',
  infinite: false,
  arrows: true,
  dots: false,
  focusOnSelect: true,
  prevArrow: '<button class="slick-prev slick-arrow"><span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.99805L7.5 5.99805L4.5 8.99805" stroke="#190B41" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>',
  nextArrow: '<button class="slick-next slick-arrow"><span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.99805L7.5 5.99805L4.5 8.99805" stroke="#190B41" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      }
    }
  ]
});

// :: END :: Product Gallery v1, v2, v3

//Zoom icon auto tigger start
jQuery('.pgs-button').click(function(){
  jQuery('.slick-current.slick-active').find('.product__media-toggle').trigger('click');
});

/* CUSTOM CART DRAWER -- JS START */

// ============================================================
// EARLY OVERRIDE: Remove data-hpn-subfix-atc from offer buttons
// This prevents the inline HPN script from intercepting offer products
// ============================================================
(function() {
  function disableInlineScriptForOffers() {
    console.log("[OFFER] Checking for offer products to disable inline HPN script");

    // Check if this is an offer product page
    var isOfferPage = document.querySelector('.protein_offer') !== null;
    if (!isOfferPage) {
      console.log("[OFFER] Not an offer product page, inline script can run normally");
      return;
    }

    console.log("[OFFER] === OFFER PRODUCT DETECTED - DISABLING INLINE HPN SCRIPT ===");

    // Remove data-hpn-subfix-atc from the add button so inline script won't match it
    var addBtn = document.querySelector('[name="add"][data-hpn-subfix-atc="1"]');
    if (addBtn) {
      console.log("[OFFER] Removing data-hpn-subfix-atc attribute from add button");
      addBtn.removeAttribute('data-hpn-subfix-atc');
      console.log("[OFFER] Inline HPN script will now ignore this button");
    }
  }

  // Run immediately when script loads
  disableInlineScriptForOffers();

  // Also run on DOM ready in case page structure changes
  document.addEventListener('DOMContentLoaded', function() {
    disableInlineScriptForOffers();
  });
})();

/* CUSTOM CART DRAWER -- JS START */

function openMiniCart(cartContainer){
  cartContainer.addClass('cart-drawer-open');
  jQuery('body').addClass('cartcustom-drawer-open');
}
function closeMiniCart(){
  jQuery('.mini_cart').each(function(){
   jQuery(this).removeClass('cart-drawer-open');
  });
  jQuery('body').removeClass('cartcustom-drawer-open');
}
jQuery(document).on('click','.cart_close_btn',function(){
  closeMiniCart();
})
// Decided at pointerdown: the opening click must not close the drawer, and drawer buttons
// that re-render the list detach their target before the click handler runs.
var closeCartOnClick = false;
document.addEventListener('pointerdown', function(e){
  closeCartOnClick = document.body.classList.contains('cartcustom-drawer-open') &&
    !(e.target.closest && e.target.closest('.cart-summary'));
}, true);
document.addEventListener('click', function(){
  if(closeCartOnClick && document.body.classList.contains('cartcustom-drawer-open')) closeMiniCart();
  closeCartOnClick = false;
});
$('#cart-icon-bubble').on('click',function (e) {
  if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
    e.preventDefault();
    const $cartContainer = $(this);
    openMiniCart($cartContainer);
  }
});

function drawerOpen(){
  if(jQuery('.cart-summary').hasClass('enbled-custom-drawer') || jQuery('body').hasClass('cart-progress_first')){
    var isOpeningDrawer = !jQuery('body').hasClass('cartcustom-drawer-open');

    if(isOpeningDrawer){
      jQuery('.cart-summary').addClass('cart-drawer-loading');
    }

    jQuery('body').addClass('cartcustom-drawer-open');

    jQuery.getJSON('/cart.js', function(cart) {
        let cartData = cart.items;
        let cartstr = '';
        let subTotal = 0;
        var cartCounter=0;
        let totalCart = cartData.length;
        if(cartData.length>0){
          subTotal = cart.original_total_price;
        }
        var tempCounter=0;
        let productHasSale = false;
        let productCompareAtPrice = 0;
        let productFinalPrice = 0;

        $.each(cartData, function(index, item) {
          let savingPercentage=0;
          let comparePrice = 0;
          var variantId = item.variant_id;
          var productId = item.product_id;
          var productTitle = item.title;
          var image = item.featured_image['url'];
          // final_line_price already has any line-level discount (e.g. the
          // Bundle Builder Function's _bundle_item % off) subtracted —
          // item.price never does, so a discounted bundle line was showing
          // its full undiscounted price here even though checkout charges
          // correctly. Equivalent to item.price when nothing's discounted.
          var priceMain = Shopify.formatMoney(item.final_line_price / item.quantity);
          var productHandle = item.handle;
          // Call the getProductData function with the product handle and the callback function
          var qunatity = item.quantity;
          var optionsdata = item.options_with_values;
          cartstr+='<div class="cart-summary__product" id="product_'+variantId+'">';
          cartstr+='<div class="cart-summary__product-image">';
          cartstr+='<img class="cart-item-media" alt="" src="'+image+'">';
          cartstr+='</div>';
          cartstr+='<div class="cart-summary__product__description">';
          cartstr+='<div class="cart-summary__product-title">';
          cartstr+='<h4 class="cart-product-title"><a href="/products/'+productHandle+'" title="">'+productTitle+'</a></h4>';
          $.ajax({
              dataType: 'json',
              async: false,
              cache: false,
              url: `/products/${item.handle}.js`,
              success(data) {
                let productData = data;
                // If item has more than one variant, need to make sure we are pulling data from the correct variant
                if (productData.variants) {
                  const itemVariants = productData.variants;
                  if (itemVariants.length > 1) {
                    for (let v = 0; v < itemVariants.length; v++) {
                      if (itemVariants[v].id === item.id) {
                        productData = itemVariants[v];
                      }
                    }
                  }
                }

                // If compare at price exists then item is on sale
                if (productData.compare_at_price!="") {
                  if (productData.compare_at_price > productData.price) {
                    productHasSale = true;
                    productCompareAtPrice = Shopify.formatMoney(productData.compare_at_price);
                    productFinalPrice = productData.price;
                    var vPrice = parseFloat(productData.compare_at_price / 100);
                    var price = parseFloat(productData.price / 100);
                    if (vPrice > price) {
                      comparePrice = parseFloat(productData.compare_at_price);
                      comparePrice = Shopify.formatMoney(comparePrice);

                      var saving = ((vPrice - price) / vPrice) * 100;
                      savingPercentage = Math.round(saving);
                    }
                  } else {
                    // Check required for non-sale items
                    productHasSale = false;
                  }
                } else {
                  // Check required for non-sale items
                  productHasSale = false;
                }
              },
          });
          var compareString = '';
          if(comparePrice!=0){
            compareString+='<span class="c_price_compare">'+comparePrice+'</span>';
          }
          var savingString = '';
          if(savingPercentage!=0){
            savingString+='<span class="cart-product-pricesave">SAVE '+savingPercentage+'%</span>';
          }

          //cartstr+='<div class="cart_product_removeicon product-remove-custom" data-variantid="'+variantId+'" data-pcartid="'+productId+'">';
          //cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">';
          //cartstr+='<path d="M16.6667 5.0013H13.3333V4.16797C13.3333 3.50493 13.0699 2.86904 12.6011 2.4002C12.1323 1.93136 11.4964 1.66797 10.8333 1.66797H9.16667C8.50363 1.66797 7.86774 1.93136 7.3989 2.4002C6.93006 2.86904 6.66667 3.50493 6.66667 4.16797V5.0013H3.33333C3.11232 5.0013 2.90036 5.0891 2.74408 5.24538C2.5878 5.40166 2.5 5.61362 2.5 5.83464C2.5 6.05565 2.5878 6.26761 2.74408 6.42389C2.90036 6.58017 3.11232 6.66797 3.33333 6.66797H4.16667V15.8346C4.16667 16.4977 4.43006 17.1336 4.8989 17.6024C5.36774 18.0712 6.00363 18.3346 6.66667 18.3346H13.3333C13.9964 18.3346 14.6323 18.0712 15.1011 17.6024C15.5699 17.1336 15.8333 16.4977 15.8333 15.8346V6.66797H16.6667C16.8877 6.66797 17.0996 6.58017 17.2559 6.42389C17.4122 6.26761 17.5 6.05565 17.5 5.83464C17.5 5.61362 17.4122 5.40166 17.2559 5.24538C17.0996 5.0891 16.8877 5.0013 16.6667 5.0013ZM8.33333 4.16797C8.33333 3.94695 8.42113 3.73499 8.57741 3.57871C8.73369 3.42243 8.94565 3.33464 9.16667 3.33464H10.8333C11.0543 3.33464 11.2663 3.42243 11.4226 3.57871C11.5789 3.73499 11.6667 3.94695 11.6667 4.16797V5.0013H8.33333V4.16797ZM14.1667 15.8346C14.1667 16.0556 14.0789 16.2676 13.9226 16.4239C13.7663 16.5802 13.5543 16.668 13.3333 16.668H6.66667C6.44565 16.668 6.23369 16.5802 6.07741 16.4239C5.92113 16.2676 5.83333 16.0556 5.83333 15.8346V6.66797H14.1667V15.8346Z" fill="#13043D"/></path>';
          //cartstr+='</svg></div>';
          cartstr+='</div>';
          cartstr+='<div class="cart-summary__variantgroup"><div class="cart_product__variant hk">';
            if(optionsdata.length>0){
              for(var t=0;t<optionsdata.length;t++){
                if (optionsdata[t].value != 'Default Title' ){
                cartstr+='<div class="added-notice__variant">';
                cartstr+='<span class="cpv-label added-notice__variant-label">'+optionsdata[t].name.replace('Protein ','')+':</span>';
                cartstr+='<span class="cpv-value added-notice__variant-value">'+optionsdata[t].value+'</span>';
                cartstr+='</div>';
                  }
              }
          }
          cartstr+='</div></div>';
          //console.log("priceMain",priceMain);
          cartstr+='<div class="cart_product_variantquantity">';
          cartstr+='<div class="cart-summary__product__variants">';
          cartstr+='<div class="cart_product__pricebox">';
          cartstr+=compareString;
          if(item.price!=0){
            cartstr+='<span class="c_price_sale">'+priceMain+'</span>';
          }else{
            cartstr+='<span class="c_price_sale">Free</span>';
          }
          cartstr+=savingString;
          cartstr+='</div></div>';
          var classQnt = ''
          if(qunatity==1){
            classQnt = 'minimum-quantity';
          }
          if(item.price!=0){
            cartstr+='<div class="cart_product_quntitybox '+classQnt+'">';
            cartstr+='<div class="qty-container">';
            cartstr+='<button class="quantity-ctas qty-btn-minus btn-light" type="button" data-pcartid="'+productId+'">';
            cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" class="minus-svg">';
            cartstr+='<path d="M11.0807 7.58073H2.91406V6.41406H11.0807V7.58073Z" fill="#717171"/></path></svg>';
            cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" class="trash-svg">';
            cartstr+='<path d="M4.56734 12.8125C4.25568 12.8125 3.98943 12.7021 3.76859 12.4814C3.54786 12.2606 3.4375 11.9943 3.4375 11.6827V3.75H2.8125V2.8125H5.625V2.25969H9.375V2.8125H12.1875V3.75H11.5625V11.6827C11.5625 11.9984 11.4531 12.2656 11.2344 12.4844C11.0156 12.7031 10.7484 12.8125 10.4327 12.8125H4.56734ZM10.625 3.75H4.375V11.6827C4.375 11.7388 4.39302 11.7849 4.42906 11.8209C4.4651 11.857 4.5112 11.875 4.56734 11.875H10.4327C10.4808 11.875 10.5248 11.855 10.5648 11.8148C10.6049 11.7748 10.625 11.7308 10.625 11.6827V3.75ZM5.8775 10.625H6.81484V5H5.8775V10.625ZM8.18516 10.625H9.1225V5H8.18516V10.625Z" fill="#717171"/></svg>';
            cartstr+='</button><input type="text" name="quantity" data-variantid="'+variantId+'" id="pquantity_'+variantId+'" value="'+qunatity+'" class="input-qty qunatity-picker-custom">';
            cartstr+='<button class="quantity-ctas qty-btn-plus btn-light" type="button" data-pcartid="'+productId+'">';
            cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">';
            cartstr+='<path d="M11.0807 7.58073H7.58073V11.0807H6.41406V7.58073H2.91406V6.41406H6.41406V2.91406H7.58073V6.41406H11.0807V7.58073Z" fill="#717171"/></path>';
            cartstr+='</svg></button></div></div>';
          }
          cartstr+='</div></div></div></div>';
          cartCounter++;
        });
        var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
        var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
        var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
        var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');

        if(cartData.length>0){
          var percentage_reached = (eval(subTotal) / eval(goalAmount));
          if(parseFloat(percentage_reached) > 100){
            var percentage_reached = 100;
          }
          jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
          jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");

          jQuery('.cc-cart-progressbar').removeClass("progress-filled");
          jQuery('.cart_shipping_box').hide();
          if(percentage_reached == 100){
            jQuery('.cart_shipping_box').show();
            jQuery('.cc-cart-progressbar').addClass("progress-filled");
          }


          var cartTotalFull = eval(subTotal) / 100;
          var tempStr = '';
          var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
          if(goalAmount > cartTotalFull){
            var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
            tempStr += goalBeforeText;
            tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
            tempStr += Shopify.formatMoney(goalPendingAmount);
            tempStr += '</span>'
            tempStr += goalAfterText;
          }
          else{
            tempStr += goalReachText;
            svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
          }
          jQuery('.cart__goal__message').html(tempStr);
          jQuery('.cc-cart-progress-heading .svg-html').html('');
          jQuery('.cc-cart-progress-heading .svg-html').html(svg);
        }
        // console.log("goalAmount", goalAmount);
        // console.log("cartTotalFull", cartTotalFull);

        // console.log("tempStr", tempStr);
        var $cartSummary = jQuery('.cart-summary');
        var $productList = jQuery('.cart-summary__product-list');

        if($cartSummary.length!=0){
          //jQuery('.cart-summary__total-quantity-row').find('span').eq(1).text(qunatity);
          //jQuery('.cart-summary__total-price-row').find('.theme-money').text(formatMoney(subTotal, theme.moneyFormatWithCodeForProductsPreference));
          // subTotal (cart.original_total_price) is pre-discount — correct for
          // the free-shipping goal math above, wrong for what the customer
          // actually owes. cart.total_price is post every line-level discount
          // (e.g. the Bundle Builder Function's % off), same number checkout
          // charges — that's what belongs in the Subtotal row.
          jQuery('.cart-summary__total-price-row').find('.theme-money').text(Shopify.formatMoney(cart.total_price));
          // The "compare at" strikethrough price is only computed once, on
          // full page load (see snippets/cart-drawer.liquid's initial
          // total_compare_at_price loop) — this AJAX rebuild never
          // recalculates it, so it goes stale (and can end up higher OR
          // lower than the real total) the moment the cart changes without a
          // full reload. Clearing it here is safer than leaving a wrong
          // number on screen; recomputing it properly would need the same
          // per-item on-sale/has-discount logic duplicated client-side.
          jQuery('.subtotal_compare_price').empty();
          jQuery('.cart-summary__product-list').html('');
          jQuery('.header-cart__count').text(totalCart);
        }

        jQuery('.cart_product__count').html('('+cart.item_count+')');
        jQuery('.header-cart__count').html(cart.item_count);

        if(cart.item_count == 0){
          var hasRenderedCartItems = $productList.find('.cart-summary__product').length > 0;

          function finishEmptyCartTransition(){
            $productList.html('');

            jQuery('.cart_look_productbox').hide();
            jQuery('.cart-summary__footer').hide();
            jQuery('.cc-cart-progress').hide();
            jQuery('.cart-count-bubble span').eq(0).text(0);

            $cartSummary.removeClass('cart-emptying');

            var $emptyState = jQuery('.cart__empty_data');

            $emptyState
              .show()
              .addClass('cart-empty-state-enter');

            setTimeout(function(){
              $emptyState.removeClass('cart-empty-state-enter');
            },300);
          }

          if(hasRenderedCartItems){
            $cartSummary.addClass('cart-emptying');

            setTimeout(function(){
              finishEmptyCartTransition();
            },260);
          }else{
            finishEmptyCartTransition();
          }
        }
        else{
          $cartSummary.removeClass('cart-emptying');

          jQuery('.cart__empty_data')
            .hide()
            .removeClass('cart-empty-state-enter');

          jQuery('.cart_look_productbox').show();
          jQuery('.cart-summary__footer').show();
          jQuery('.cc-cart-progress').show();

          $productList.html(cartstr);

          if(jQuery('.cart-count-bubble').length==0){
            jQuery('#cart-icon-bubble span').after('<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span></div>');
          }else{
            jQuery('.cart-count-bubble span').eq(0).text(cart.item_count);
          }
        }
    }).always(function(){
      jQuery('.cart-summary').removeClass('cart-drawer-loading');
    });
  }
}


function refreshCartProgress(){
  if(jQuery('body').hasClass('cart-progress_second') || jQuery('body').hasClass('cart-progress_first')){
    jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if(cartData.length>0){
        subTotal = cart.original_total_price;
      }
      var tempCounter=0;
      let productHasSale = false;
      let productCompareAtPrice = 0;
      let productFinalPrice = 0;

      var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
      var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
      var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
      var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');

      if(cartData.length>0){
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
          jQuery('.cart-progress').removeClass("cart_progress-filled");
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
          jQuery('.cart-progress').addClass("cart_progress-filled");
        }


        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += Shopify.formatMoney(goalPendingAmount);
          tempStr += '</span>';
          tempStr += goalAfterText;
        }
        else{
          tempStr += '<span class="cart_goal_oldm">';
          tempStr += goalReachText;
          tempStr += '</span>';
          tempStr += '<span class="cart_goal_newm" style="display: none;">🎉 Congrats! You unlocked <strong>FREE shipping</strong></span>';
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none"><path d="M15.4988 6.00232H13.2488V3.00232H1.24878V12.7523H2.74878C2.74878 13.9973 3.75378 15.0023 4.99878 15.0023C6.24378 15.0023 7.24878 13.9973 7.24878 12.7523H11.7488C11.7488 13.9973 12.7538 15.0023 13.9988 15.0023C15.2438 15.0023 16.2488 13.9973 16.2488 12.7523H17.7488V9.00232L15.4988 6.00232ZM4.99878 13.5023C4.58628 13.5023 4.24878 13.1648 4.24878 12.7523C4.24878 12.3398 4.58628 12.0023 4.99878 12.0023C5.41128 12.0023 5.74878 12.3398 5.74878 12.7523C5.74878 13.1648 5.41128 13.5023 4.99878 13.5023ZM15.1238 7.12732L16.5938 9.00232H13.2488V7.12732H15.1238ZM13.9988 13.5023C13.5863 13.5023 13.2488 13.1648 13.2488 12.7523C13.2488 12.3398 13.5863 12.0023 13.9988 12.0023C14.4113 12.0023 14.7488 12.3398 14.7488 12.7523C14.7488 13.1648 14.4113 13.5023 13.9988 13.5023Z" fill="black"/></path></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }

      if(cart.item_count == 0){
        jQuery('.cc-cart-progress').hide();
      }
      else{
        jQuery('.cc-cart-progress').show();
      }

    });
  }
}

setInterval(function() {
refreshCartProgress();
},1000);

function waitForCartCleanupAfterRemoval(initialItemCount){
  var cleanupAttempts = 0;
  var maxCleanupAttempts = 12;
  var cleanupDelay = 250;

  function checkCartCleanup(){
    cleanupAttempts++;

    jQuery.getJSON('/cart.js')
      .done(function(updatedCart){
        if(updatedCart.item_count !== initialItemCount){
          drawerOpen();
          return;
        }

        if(cleanupAttempts < maxCleanupAttempts){
          setTimeout(checkCartCleanup, cleanupDelay);
        }
      })
      .fail(function(){
        if(cleanupAttempts < maxCleanupAttempts){
          setTimeout(checkCartCleanup, cleanupDelay);
        }
      });
  }

  setTimeout(checkCartCleanup, cleanupDelay);
}

function updateCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      $('.qty-container').removeClass('is-loading');

      drawerOpen();

      if(Number(Quantity) === 0){
        waitForCartCleanupAfterRemoval(cart.item_count);
      }
    },
    error: function(response) {
      $('.qty-container').removeClass('is-loading');
        //alert(response);
    }
  });
}

jQuery(document).on('click','.product_add_btn',function(e){
  if(jQuery('.combine_supplements_v1').length!=0){
    var variantId='';
    variantId = jQuery(this).attr('data-vid');
    addUpsellItemCart(1,variantId);
  }
});

jQuery(document).on('change','.product_add_sel',function(e){
  if(jQuery('.combine_supplements_v1').length!=0){
    var variantId='';
    variantId = jQuery(this).val();
    addUpsellItemCart(1,variantId);
    jQuery(this).prop('selectedIndex',0);
    // prevent click action
    e.preventDefault();
    // your code here
    return false;
  }
});

function addUpsellItemCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      console.log("iinnn->", cart)
      //window.location.reload;
      jQuery.getJSON('/cart.js', function(cart1) {
        console.log("parsedState--->", cart1)
        var cartItemCount = cart1.item_count;
        var cartCountStr = '';
        if(cartItemCount > 0){
          jQuery('.cart-count-bubble span').eq(0).text(cartItemCount);
          if(cartItemCount == 1){
            cartCountStr = cartItemCount+' item';
          }
          else{
            cartCountStr = cartItemCount+' items';
          }
          jQuery('.cart-count-bubble span').eq(1).text(cartItemCount);

          var cartTotalAmount = cart1.total_price;
          var cartDiscount = cart1.cart_level_discount_applications;
          if(cartDiscount.length > 0){
            console.log("title--->", cartDiscount[0].title)
            var svgStr = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></svg>';
            var discountStr = svgStr + cartDiscount[0].title + ' (-'+Shopify.formatMoney(cartDiscount[0].total_allocated_amount)+')';
            jQuery('.discounts__discount--end').html(discountStr);
          }

          var currencySign = jQuery('#in-context-paypal-metadata').attr('data-currency');
          jQuery('.totals__subtotal-value').text(Shopify.formatMoney(cartTotalAmount)+ ' '+currencySign);

          var cartItemStr = '';
          var counter = 1;
          cart1.items.forEach(function(item) {
            console.log("Item Details:", item);

            // Example: Access item properties
            var itemTitle = item.title; // Title of the product
            var itemQuantity = item.quantity; // Quantity of the product
            var itemPrice = item.price; // Convert price from cents to dollars/euros
            var itemImage = item.image; // Product image URL
            var itemVariantId = item.variant_id; // Variant ID
            var itemUrl = item.url; // Product URL
            var itemVendor = item.vendor; // Product Vendor
            var itemvariant_title = item.variant_title;
            var itemPid = item.product_id;

            jQuery('[data-pid="'+itemPid+'"]').hide();
            // Example: Log details or use in your UI
            console.log(`Title: ${itemTitle}`);
            console.log(`Quantity: ${itemQuantity}`);
            console.log(`Price: ${itemPrice}`);
            console.log(`Image: ${itemImage}`);
            console.log(`Variant ID: ${itemVariantId}`);

            cartItemStr += '<tr class="cart-item" id="CartItem-'+counter+'">';
            cartItemStr += '<td class="cart-item__media">';
            cartItemStr += '<a href="'+itemUrl+'" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>';
            cartItemStr += '<img class="cart-item__image" src="'+itemImage+'" alt="'+itemTitle+'" loading="lazy" width="150" height="150">';
            cartItemStr += '</td>';
            cartItemStr += '<td class="cart-item__details">';
            cartItemStr += '<p class="caption-with-letter-spacing light">'+itemVendor+'</p><a href="'+itemUrl+'" class="cart-item__name break">'+itemTitle+'</a><dl><div class="product-option">';
            cartItemStr += '<dt>Flavor:</dt>';
            cartItemStr += '<dd>'+itemvariant_title+'</dd>';
            cartItemStr += '</div></dl>';
            cartItemStr += '<p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>';
            cartItemStr += '<div class="cart-item__error" id="Line-item-error-'+counter+'" role="alert">';
            cartItemStr += '<small class="cart-item__error-text"></small>';
            cartItemStr += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">';
            cartItemStr += '<circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>';
            cartItemStr += '<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>';
            cartItemStr += '<path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>';
            cartItemStr += '<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">';
            cartItemStr += '</svg>';
            cartItemStr += '</div>';
            cartItemStr += '</td>';

            cartItemStr += '<td class="cart-item__totals right medium-hide large-up-hide">';
            cartItemStr += '<div class="loading-overlay hidden">';
            cartItemStr += '<div class="loading-overlay__spinner">';
            cartItemStr += '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
            cartItemStr += '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
            cartItemStr += '</svg>';
            cartItemStr += '</div>';
            cartItemStr += '</div>';
            cartItemStr += '<div class="cart-item__price-wrapper"><span class="price price--end">';
            cartItemStr += Shopify.formatMoney(itemPrice);
            cartItemStr += '</span></div>';
            cartItemStr += '</td>';

            cartItemStr += '<td class="cart-item__quantity">';
            cartItemStr += '<label class="visually-hidden" for="Quantity-'+counter+'">';
            cartItemStr += 'Quantity';
            cartItemStr += '</label>';
            cartItemStr += '<quantity-input class="quantity">';
            cartItemStr += '<button data-pid="'+itemPid+'" class="quantity__button no-js-hidden" name="minus" type="button">';
            cartItemStr += '<span class="visually-hidden">Decrease quantity for '+itemTitle+'</span>';
            cartItemStr += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">';
            cartItemStr += '<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">';
            cartItemStr += '</svg>';
            cartItemStr += '</button>';
            cartItemStr += '<input class="quantity__input" type="number" name="updates[]" value="'+item.quantity+'" min="0" aria-label="Quantity for '+itemTitle+'" id="Quantity-'+counter+'" data-index="'+counter+'" >';
            cartItemStr += '<button class="quantity__button no-js-hidden" name="plus" type="button" >';
            cartItemStr += '<span class="visually-hidden">Increase quantity for '+itemTitle+'</span>';
            cartItemStr += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">';
            cartItemStr += '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">';
            cartItemStr += '</svg>';
            cartItemStr += '</button>';
            cartItemStr += '</quantity-input>';

            cartItemStr += '<cart-remove-button id="Remove-'+counter+'" data-index="'+counter+'" class="remove_product_cart" data-pid="'+itemPid+'">';
            cartItemStr += '<a href="/cart/change?id='+item.key+'&quantity=0" class="button button--tertiary" aria-label="Remove '+itemTitle+' - '+itemvariant_title+'" >';
            cartItemStr += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">';
            cartItemStr += '<path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>';
            cartItemStr += '<path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>';
            cartItemStr += '</svg>';
            cartItemStr += '</a>';
            cartItemStr += '</cart-remove-button>';
            cartItemStr += '</td>';

            cartItemStr += '<td class="cart-item__totals right small-hide">';
            cartItemStr += '<div class="loading-overlay hidden">';
            cartItemStr += '<div class="loading-overlay__spinner">';
            cartItemStr += '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
            cartItemStr += '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
            cartItemStr += '</svg>';
            cartItemStr += '</div>';
            cartItemStr += '</div>';
            cartItemStr += '<div class="cart-item__price-wrapper"><span class="price price--end">';
            cartItemStr += Shopify.formatMoney(itemPrice);
            cartItemStr += '</span></div>';
            cartItemStr += '</td>';
            cartItemStr += '</tr>';
            counter++;
          });
          jQuery('#cart__item__list').html(cartItemStr);

          setTimeout(function() {
            var totalLength = 0;
            var totalLoopItem = 0;
            jQuery('.combine_supplements_v1').find('.combine_main_card').find('.combine_card').each(function() {
              totalLoopItem++;
              if($(this).css('display') == 'none'){
                totalLength++;
              }
            });

            if(totalLoopItem == totalLength){
              jQuery('.combine_supplements_v1').addClass('hide_sec');
            }

            var totalLength1 = 0;
            var totalLoopItem1 = 0;
            jQuery('.combine_supplements_v1_2').find('.combine_main_card').find('.combine_card').each(function() {
              totalLoopItem1++;
              if($(this).css('display') == 'none'){
                totalLength1++;
              }
            });

            if(totalLoopItem1 == totalLength1){
              jQuery('.combine_supplements_v1_2').addClass('hide_sec');
            }
          }, 500);

        }
      });
      return false;
    },
    error: function(response) {
        alert('Something went wrong!!');
    }
  });
}

setInterval(function() {
  var totalLength = 0;
  var totalLoopItem = 0;
  var totalLength1 = 0;
  var totalLoopItem1 = 0;
  jQuery('.combine_supplements_v1').find('.combine_main_card').find('.combine_card').each(function() {
    totalLoopItem++;
    if($(this).css('display') == 'none'){
      totalLength++;
    }
  });

  jQuery('.combine_supplements_v1_2').find('.combine_main_card').find('.combine_card').each(function() {
    totalLoopItem1++;
    if($(this).css('display') == 'none'){
      totalLength1++;
    }
  });

  if(totalLoopItem == totalLength){
    jQuery('.combine_supplements_v1').addClass('hide_sec');
  }
  else{
    jQuery('.combine_supplements_v1').removeClass('hide_sec');
  }

  if(totalLoopItem1 == totalLength1){
    jQuery('.combine_supplements_v1_2').addClass('hide_sec');
  }
  else{
    jQuery('.combine_supplements_v1_2').removeClass('hide_sec');
  }
}, 100);

jQuery(document).on("click",".remove_product_cart",function(){
  if(jQuery('.combine_supplements_v1').length!=0){
    var productId = jQuery(this).attr('data-pid');
    setTimeout(function(){
      jQuery('.combine_main_card').find('.combine_card[data-pid="'+productId+'"]').show();
    },1000);
  }
});

jQuery(document).on("click","#main-cart-items [name='minus']",function(){
  if(jQuery('.combine_supplements_v1').length!=0){
    var productId = jQuery(this).attr('data-pid');
    var quantity = jQuery(this).siblings('.quantity__input').val();
    if(eval(quantity)==0){
      setTimeout(function(){
        jQuery('.combine_main_card').find('.combine_card[data-pid="'+productId+'"]').show();
      },1000);
    }
  }
});

jQuery(document).ready(function(){
  setTimeout(function(){
    var upsellCount = jQuery('#upsell_count').val();
    if(eval(upsellCount) == eval(jQuery('.combine_card').length)){
      jQuery('.cart_upsell_box').addClass("hide_upsell");
    }
  },1000);
});

jQuery(document).on('change','.qunatity-picker-custom',function(){
  var variantIdExist = jQuery(this).attr('data-variantid');
  var Quantity = jQuery(this).val();
  updateCart(Quantity,variantIdExist);
});

jQuery(document).on('click','.product-remove-custom',function(){
  var variantIdExist = jQuery(this).attr('data-variantid');
  updateCart(0,variantIdExist);
});

jQuery(document).on('click','.qty-btn-plus',function(){
  $(this).parent().addClass('is-loading');
  var $n = $(this)
  .parent(".qty-container")
  .find(".input-qty");
  $n.val(Number($n.val())+1 );
  var variantIdExist = $(this).parent('div').find('.qunatity-picker-custom').attr('data-variantid');
  var Quantity = $(this).parent('div').find('.qunatity-picker-custom').val();
  updateCart(Quantity,variantIdExist);
});

jQuery(document).on('click','.qty-btn-minus',function(){
  $(this).parent().addClass('is-loading');
  var $n = $(this)
  .parent(".qty-container")
  .find(".input-qty");
  var amount = Number($n.val());
  if (amount >= 1) {
    $n.val(amount-1);
  }
  var variantIdExist = $(this).parent('div').find('.qunatity-picker-custom').attr('data-variantid');
  var Quantity = $(this).parent('div').find('.qunatity-picker-custom').val();

  if(Quantity == 0){
    setTimeout(function(){
      var productId = $(this).attr('data-pcartid');
      jQuery('[product--id="'+productId+'"]').parent('div').show();
      jQuery('[product--id="'+productId+'"]').find('.btn__text').show();
    },1000);
  }

  updateCart(Quantity,variantIdExist);
});

jQuery('.product-form__buttons').click(function(){
  if(!jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
    return;
  }

  var submitButton = jQuery(this).find('[name="add"], .product-form__submit').first()[0];

  if(!submitButton){
    return;
  }

  var sawLoading = submitButton.classList.contains('loading');

  var drawerObserver = new MutationObserver(function(){
    if(submitButton.classList.contains('loading')){
      sawLoading = true;
      return;
    }

    if(sawLoading){
      drawerObserver.disconnect();
      drawerOpen();
    }
  });

  drawerObserver.observe(submitButton, {
    attributes: true,
    attributeFilter: ['class']
  });

  setTimeout(function(){
    drawerObserver.disconnect();
  },10000);
});

/* CUSTOM CART DRAWER -- JS END */

jQuery(document).on('click','.cusom-add-btn',function(){
   var variantId = $(this).attr('data-vid');
   addItemCart(1,variantId);
});


// MENU DRAWER

jQuery('.header__icon--menu').click(function(){
  jQuery('body').toggleClass('drawer_model__open');
  headerBaseSetHigthMenu();
})
jQuery(window).scroll(function(){
  headerBaseSetHigthMenu();
});
function headerBaseSetHigthMenu(){
  var announceHeight1=0;
  if(jQuery('#shopify-section-header').hasClass('shopify-section-header-sticky')){

  }else{
    announceHeight1 = document.querySelector('#shopify-section-announcement-bar');
    announceHeight1=announceHeight.clientHeight;
  }
  //console.log('announceHeight1',announceHeight1);
  var windowHeight = $(window).height();
  //console.log('window-Height',windowHeight);
  document.documentElement.style.setProperty('--vvh', windowHeight+'px');
  windowHeight = (windowHeight-announceHeight1);
  //console.log('windowHeight',windowHeight);
  document.documentElement.style.setProperty('--vh', windowHeight+'px');
}


// jQuery(document).ready(function() {
//     var $searchBar = jQuery('#Search-In-Modal-1');
//     jQuery('body').removeClass('search-active');
//     // When the search bar gains focus
//     $searchBar.on('focus', function() {
//         // Add a class or perform some action
//         jQuery('body').removeClass('search-active');
//     });

//     // When the search bar loses focus (after pressing "Done" on the keyboard)
//     $searchBar.on('blur', function() {
//         jQuery('body').addClass('search-active');
//     });
//     $searchBar.on('focusOut', function() {
//         jQuery('body').addClass('search-active');
//     });
// });

jQuery('.modal__close-button').click(function(){
  jQuery('body').removeClass("drawer_model__open");
  jQuery('body').removeClass("overflow-hidden-tablet");
})
jQuery('.menu-drawer__menu-item').click(function(){
  jQuery('.menu-drawer__inner-container').addClass('submenu__drawer_open');
})
jQuery('.menu-drawer__close-button').click(function(){
  jQuery('.menu-drawer__inner-container').removeClass('submenu__drawer_open');
})

const headerHeight = document.querySelector('#shopify-section-header');
document.documentElement.style.setProperty('--header-height', `${headerHeight.clientHeight}px`);

const announceHeight = document.querySelector('#shopify-section-announcement-bar');
document.documentElement.style.setProperty('--announce-height', `${announceHeight.clientHeight}px`);

//redirect menu click set code start
// jQuery(document).on('click','.menu-drawer__menu-item',function(e) {
//   var menuText = jQuery(this).text();
//   menuText = menuText.trim();
//   if(jQuery('.menu-opening').length>0 && menuText == 'Our Products'){
//     e.preventDefault();
//     window.location="/collections/our-products";
//   }else if(jQuery('.menu_drawer__new').length>0 && menuText == 'Shop Supplements'){
//     e.preventDefault();
//     window.location="/collections/our-products";
//   }
// });

jQuery('.cart-summary__button').click(function(){
  $('.button-text').hide();
  $('.checkout-lock').hide();
  $('.button-loader').show();
  setTimeout(function() {
    window.location.href="/checkout";
  }, 1000);
});

$(document).ready(function() {
    getHeaderHeight();
});
function getHeaderHeight(){
  var classHeaderHeight = jQuery('.menu-drawer').innerHeight();
  document.documentElement.style.setProperty('--vh', classHeaderHeight+'px');
}
$(window).on('resize', function () {
    getHeaderHeight();
})

// start: PRODUCT LIST NEW [sections/product-list.liquid]
$(document).ready(function () {
  jQuery(".pl_nav_list li").eq(0).addClass("current");
  jQuery(".tabs-content").find(".cl_maintab-content").eq(0).addClass("current");
  $("ul.pl_nav_list li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.pl_nav_list li").removeClass("current");
    $(".cl_maintab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    $(".producttab-itemslick").slick("refresh");
  });
});
//COLLECTION TABING END
$(document).ready(function () {
var $swiperSelector = $('.swiper-container');
$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 4;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3;
    var slidesMobileinner = $this.data('slides-mobile-inner') ? $this.data('slides-mobile-inner') : 2;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 20;
    if(jQuery(window).width()<751){
      var lengthSize=Math.round(jQuery('.product-slidercount').val()/2);
      dragSize = (dragSize*lengthSize);
    }else{
      dragSize = (dragSize*jQuery('.product-slidercount').val());
    }
  setTimeout(function(){
    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop
        },
        991: {
          slidesPerView: slidesTablet
        },
        751: {
           slidesPerView: slidesMobile
        },
        300: {
           slidesPerView: slidesMobileinner
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      }
   });
  },500);
});
});
// end: PRODUCT LIST NEW [sections/product-list.liquid]

jQuery(function(){
    createSticky(jQuery('#shopify-section-header'));
});
function createSticky(sticky) {

    if (typeof sticky !== "undefined") {

        var pos = sticky.offset().top,
                win = jQuery(window);

        win.on("scroll", function() {
            if(win.scrollTop()==pos){
                sticky.removeClass("fixed");
            }else{
            win.scrollTop() >= pos ? sticky.addClass("fixed") : sticky.removeClass("fixed");
            }
        });
    }
}

jQuery('.variant__select').click(function(){
  var vtype = $(this).attr('data-type');
  $('.bundle_prog_step').removeClass('active');
  if(vtype == 'single tub'){
    var width = '25%';
    var progressMess = '<p>Add <b><span>1</span> more tub</b> to unlock <b>FREE</b> Shipping and Shaker</p>';
    $('.bundle_prog_step_1').addClass('active');
  }
  if(vtype == '2-pack'){
    var width = '75%';
    var progressMess = '<p>Add <b><span>1</span> more tub</b> to unlock Protein Samples</p>';
    $('.bundle_prog_step_1').addClass('active');
    $('.bundle_prog_step_2').addClass('active');
    $('.bundle_prog_step_3').addClass('active');
  }
  if(vtype == '3-pack'){
    var width = '100%';
    var progressMess = '<p><b>Congratulations, </b> you get all free gifts</p>';
    $('.bundle_prog_step_1').addClass('active');
    $('.bundle_prog_step_2').addClass('active');
    $('.bundle_prog_step_3').addClass('active');
    $('.bundle_prog_step_4').addClass('active');
  }
  $('.bundle_progress_fill').css('width', width);
  $('.bundle_progress_message').html(progressMess);
});


/* SEARCH BAR -- START */

setTimeout(function() {
    $('.search-modal__content').addClass('search-modal-new');
    $('.search-modal').addClass('main__search');
    $('.main__search #Search-In-Modal').attr('placeholder', 'Creatine, Protein, BCAA...');
}, 500);
var searchbutton = setInterval(function() {
    if($('.main__search .search-modal__form[results="true"]').length != 0){
        $('.main__search .search-modal__form[results="true"] .search_result__btn > span').text('VIEW ALL RESULTS');
        // clearInterval(searchbutton);
    }
}, 100);

/* SEARCH BAR -- END */

/* PAGINATION INFINITE LOADING -- START */

/*convert.$(document).ready(function(){
  let page = 2;
  let loading = false;
  let totalHeightminus = 1000;
  let totalPerPage = jQuery('#per_page_collection').val();
  let totalCollectionProduct=jQuery('#collection_total_products').val();
  let totalPage = Math.ceil(totalCollectionProduct/totalPerPage);
  let collectionUrl = jQuery('#collection_url').val();
  $(window).scroll(function() {
    var loadMoreThreshold = Math.round(jQuery('#product-grid').find('.Grid__Cell').last().offset().top); // Adjust this value based on your preference
    var finalHeight = (loadMoreThreshold);
    console.log("scroll height",$(window).scrollTop());
    console.log("final height",finalHeight);
    if (!loading && $(window).scrollTop() > finalHeight) {
      loadMore();
    }
  });
  function loadMore() {
    if (!loading) {
      loading = true;
      console.log("page",page);
      if(totalPage>=page){
        jQuery("#load-more-btn-wrapper").show();
        var url = window.location.origin + "/" + collectionUrl + "?page=" + page;
          //added for filter data for query string with filter start
          var queryString = window.location.search; // Includes the '?' at the start
          if(queryString!=""){
            var rawQueryString = queryString.substring(1);
            url = window.location.origin + "/" + collectionUrl + "?page=" + page+'&'+rawQueryString;
          }
        $.get(url, function(data) {
          //console.log("product",data);
          var newProducts = $(data).find('.ProductList--grid').html();
          if (newProducts.trim().length > 0) {
          $('#product-grid').append(newProducts);
          page++; // Increment page only if new products are loaded

          }else{
            loading = false;
              jQuery("#load-more-btn-wrapper").hide();
          }

        }).fail(function() {
            loading = false; // Reset loading flag in case of failure
        });
      }else{
        loading=true;
        jQuery('#load-more-btn-wrapper').hide();
      }
    }
  }
});*/
function initializeLoadMorePagination() {
  console.log("load more calls");
  let page = 2;
  let loading = false;
  let totalHeightminus = 1000;

  let totalPerPage = parseInt(jQuery("#per_page_collection").val()) || 12;
  let totalCollectionProduct = parseInt(jQuery("#collection_total_products").val()) || $(".Grid__Cell").length;
  let collectionUrl = jQuery("#collection_url").val() || window.location.pathname.replace(/^\/+/, '');

  let totalPage = Math.ceil(totalCollectionProduct / totalPerPage);

  $(window).off("scroll.loadMore");

  if (totalCollectionProduct < totalPerPage) {
    jQuery("#load-more-btn-wrapper").hide();
    return;
  }

  $(window).on("scroll.loadMore", function () {
    const $lastProduct = $('#product-grid').find(".Grid__Cell").last();
    if ($lastProduct.length === 0) return;

    let loadMoreThreshold = Math.round($lastProduct.offset().top);
    let finalHeight = loadMoreThreshold - totalHeightminus;

    if (!loading && $(window).scrollTop() > finalHeight) {
      if (totalPage >= page) {
        loadMore();
      } else {
        loading = false;
        jQuery("#load-more-btn-wrapper").hide();
      }
    }
  });

  function loadMore() {
    if (!loading) {
      loading = true;
      let url = window.location.origin + "/" + collectionUrl + "?page=" + page;

      const queryString = window.location.search;
      if (queryString) {
        const rawQueryString = queryString.substring(1);
        url = window.location.origin + "/" + collectionUrl + "?page=" + page + '&' + rawQueryString;
      }

      $.get(url, function (data) {
        const newProducts = $(data).find(".ProductList--grid").html();
        if (newProducts && newProducts.trim().length > 0) {
          if(totalPage>=page){
            jQuery("#load-more-btn-wrapper").show();
          }else{
            jQuery("#load-more-btn-wrapper").hide();
          }
          $('.collection').find('#product-grid').append(newProducts);
        } else {
          jQuery("#load-more-btn-wrapper").hide();
        }
        loading = false;
        page++;
      }).fail(function () {
        loading = false;
        jQuery("#load-more-btn-wrapper").hide();
      });
    }
  }
}

jQuery(document).ready(function(){
  setTimeout(function(){
    jQuery("#load-more-btn-wrapper").hide();
  },7000);
  var pdcount = setInterval(function(){
    if(jQuery('.active-facets').find('.active-facets__button.active-facets__button--light').length>0){
      jQuery('.facets_apply_btn_count').show();
      var totalProducts = jQuery('#collection_total_products').val();
      jQuery('.facets_apply_btn_count').text('('+totalProducts+')');
    }else{
      jQuery('.facets_apply_btn_count').hide();
    }

  },500);
})

// Fallback for filter remove (in case event doesn't fire)
$(document).on("click", ".active-facets__button.active-facets__button--light", function () {
  setTimeout(() => {
    initializeLoadMorePagination();
  }, 500);
});

// Initialize the function when the document is ready
convert.$(document).ready(function () {
  initializeLoadMorePagination();
});

/*jQuery(document).on("click",".facets-container .active-facets__button-wrapper",function(){
  setTimeout(function(){
    initializeLoadMorePagination();
  },1000);
});
*/
jQuery(document).on("change",".mobile-facets__checkbox[type='checkbox']",function(){
  $('.collection').find('#product-grid').html('');
  setTimeout(function(){
    initializeLoadMorePagination();
    resetPriceSliderUI();
  },1000);
});

jQuery(document).on("change","#SortBy-mobile",function(){
  $('.collection').find('#product-grid').html('');
  setTimeout(function(){
    initializeLoadMorePagination();
  },1000);
});

jQuery(document).ready(function () {
  jQuery(document).on('click',"#SortByList li",function () {
    var selectedSort = jQuery(this).data("value");
    jQuery("#SortBy-mobile").val(selectedSort);

    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("sort_by", selectedSort);
    window.history.pushState({}, '', currentUrl.href);
    //initializeLoadMorePagination();
    jQuery.ajax({
      url: currentUrl.pathname + currentUrl.search,
      type: "GET",
      dataType: "html",
      success: function (data) {
        var sortingData = jQuery(data).find("#ProductGridContainer").find("#product-grid").html();
        if(sortingData!=undefined){
          $('.collection').find('#product-grid').html('');
          $('.collection').find('#product-grid').append(sortingData);
        }
      },
      error: function (err) {
        console.log("Sort failed", err);
      }
    });
  });
});

/* PAGINATION INFINITE LOADING -- END */
jQuery(document).on('click','.add__btn_custom_button',function(e){
  var variantId='';
  variantId = jQuery(this).attr('data-vid');
  if(variantId != ''){
    var objBtn = jQuery(this);
    $(this).hide();
    $(this).closest('.form').find('[name="id"]').val(variantId);
    $(this).closest('.form').find('.add__custom_loader').show();
    //$(this).closest('.form').find('[name="add"]').trigger('click');
    var itemArr = []
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
       if (window.updateConvertAttributes) window.updateConvertAttributes();
         if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
          setTimeout(function(){
            if(jQuery('.add__custom_loader').length>0){
              jQuery('.add__custom_loader').hide();
              objBtn.show();
            }
          },3000);
          drawerOpen();
        }else{
          window.location.href = '/cart';
        }
      },
      error: function(response) {
          alert('Something went wrong!!');
      }
    });
  }
  e.preventDefault();
  return false;
});

jQuery(document).on('change','.add__btn_custom_sel',function(e){
  var variantId='';
  variantId = jQuery(this).val();
  if(variantId != ''){
    var objBtn = $(this);
    $(this).hide();
    $(this).closest('.form').find('.add__custom_loader').show();
    $(this).closest('.form').find('[name="id"]').val(variantId);
    //$(this).closest('.form').find('[name="add"]').trigger('click');
    jQuery(this).val('');
    var itemArr = []
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
       if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
          setTimeout(function(){
            if(jQuery('.add__custom_loader').length>0){
              jQuery('.add__custom_loader').hide();
              objBtn.show();
            }
          },3000);
          drawerOpen();
        }else{
          window.location.href = '/cart';
        }
      },
      error: function(response) {
          alert('Something went wrong!!');
      }
    });
  }
  e.preventDefault();
  return false;
});


//PDP Details Page Radio Click Event
jQuery(document).on("change","[name='tab']",function(){
  jQuery('.main-teb').find('.tabing').removeClass("active");
  jQuery('.main-article').find('.article-section').hide();
  if(jQuery(this).is(":checked")){
    var radioVal = jQuery(this).val();
    ProductOfferSwitch(radioVal);
  }
});

jQuery(document).ready(function(){
  var radioVal = jQuery("[name='tab']:checked").val();
  ProductOfferSwitch(radioVal);
});

function ProductOfferSwitch(radioVal) {
  jQuery('.main-teb').find('.teb-'+radioVal).addClass("active");
  jQuery('.main-article').find(".article"+radioVal).show();
}

jQuery(document).on("change",".main-article .add__select_custom_cart",function(){
  variantPriceChange();
});
jQuery(document).on("change",".new-article .add__select_custom_cart",function(){
  variantPriceChange();
});

//Best Offer Secton Variant Wise Price Total And Price Change Start
function variantPriceChange(){
  var totalPrice = 0;
  var classBase = '.main-article';
  if(jQuery('.spacial-offer-vtwo_b').length!=0){
    classBase = '.new-article';
  }
  jQuery(classBase+' .add__select_custom_cart option:selected').each(function(){
    var priceMain = parseInt(jQuery(this).attr('data-price'));
    var comparePrice = parseInt(jQuery(this).attr('data-comprice'));
    if(priceMain!=undefined && priceMain>0){
      totalPrice+=priceMain;
      jQuery(this).parent().parent().parent('div').find('.article1-product-price').find('.price').text(Shopify.formatMoney(priceMain));
    }
    if(comparePrice!=undefined && comparePrice>0){
      jQuery(this).parent().parent().parent('div').find('.article1-product-price').find('.compare_at_price').text(Shopify.formatMoney(comparePrice));
    }
  });
  jQuery(classBase+' .article1-product-values').each(function(){
    if(jQuery(this).find('.add__select_custom_cart').length==0){
      var priceMain = parseInt(jQuery(this).siblings('.article1-product-price').find('.price').attr('data-price'));
      var comparePrice = parseInt(jQuery(this).siblings('.article1-product-price').find('.compare_at_price').attr('data-comprice'));
      if(priceMain!=undefined && priceMain>0){
        totalPrice+=priceMain;
      }
    }
  });

  if(totalPrice!=undefined){
    jQuery('.tabing.active').find('.tab_compare_price_vb .price').text(Shopify.formatMoney(totalPrice));
  }
}
//Best Offer Secton Variant Wise Price Total And Price Change End


document.addEventListener("DOMContentLoaded", function () {
    let displayElement = document.getElementById("timer-display");

    function setNewEndTime() {
        let newEndTime = Math.floor(Date.now() / 1000) + 18000; // 5 hours from now
        localStorage.setItem("countdownEndTime", newEndTime); // Save in localStorage
        return newEndTime;
    }

    let endTime = parseInt(localStorage.getItem("countdownEndTime")) || setNewEndTime();

    function updateCountdown() {
        let now = Math.floor(Date.now() / 1000);
        let timeLeft = endTime - now;

        if (timeLeft > 0) {
            let hours = Math.floor(timeLeft / 3600);
            let minutes = Math.floor((timeLeft % 3600) / 60);
            if(displayElement!=null){
              displayElement.textContent = `${hours} hours and ${minutes} minutes`;
            }
            if($('#timer-display-convert').length > 0){
              $('#timer-display-convert').html(`${hours} hours and ${minutes} minutes`);
            }
        } else {
            endTime = setNewEndTime(); // Reset timer when it reaches zero
        }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
});
const priceGap = 10;
const $rangeInput = $(".range-input input");
const $priceInput = $(".price-input input");
let $range = $(".slider .progress");

//FILTER CHECKBOX CHECKED FOR ADDED CLASS FILTER FOOTER JS STARTc
jQuery(document).ready(function(){
  setTimeout(function(){
    addClassFilter();
  },1000);
});
jQuery(document).on('change','#FacetFiltersFormMobile .mobile-facets__checkbox',function(){
  addClassFilter();
  let minVal = parseInt($rangeInput.eq(0).val());
  let maxVal = parseInt($rangeInput.eq(1).val());
  //filterExludePrice(jQuery(this));
});
jQuery(document).on('click','#FacetFiltersFormMobile .mobile-facets__clear-wrapper',function(){
  jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').removeClass('facet-filter-active');
});
function addClassFilter(){
  if(jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').length>0){
    if(jQuery('#FacetFiltersFormMobile').find('.mobile-facets__checkbox:checked').length>0){
      jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').addClass('facet-filter-active');
    }else{
      jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').removeClass('facet-filter-active');
    }
  }
}
//FILTER CHECKBOX CHECKED FOR ADDED CLASS FILTER FOOTER JS END

//FILTER PRICE RANGE PICKER JS START


// Initialize progress bar
let defaultMin=0;
let defaultMax=0;
function initializeProgress() {
  let minVal = parseInt($rangeInput.eq(0).val());
  let maxVal = parseInt($rangeInput.eq(1).val());

  if($(".slider .progress").length>0){
    $(".slider .progress").css("left", (minVal / $rangeInput.eq(0).attr("max")) * 100 + "%");
    $(".slider .progress").css("right", 100 - (maxVal / $rangeInput.eq(1).attr("max")) * 100 + "%");
  }
  setTimeout(function(){
    if(jQuery('.main_collection_container').hasClass('filter-versions')){
      $("#Mobile-Filter-Price-GTE").val(minVal);
      $("#Mobile-Filter-Price-LTE").val(maxVal);
      defaultMin = minVal;
      defaultMax = maxVal;
    }
  },1000);

  //$priceInput.eq(0).val(minVal);
  //$priceInput.eq(1).val(maxVal);
}
function resetPriceSliderUI() {
  setTimeout(function () {
    var $rangeInput = $(".range-input input");
    var $priceInput = $(".price-input input");
    var $range = $(".slider .progress");

    let minVal = parseInt($rangeInput.eq(0).attr("min"), 10) || 0;
    let maxVal = parseInt($rangeInput.eq(1).attr("max"), 10) || 1000;

    // Update progress bar after inputs are set
    setTimeout(function () {
      if ($range.length > 0) {
        let newMin = parseInt($rangeInput.eq(0).val(), 10);
        let newMax = parseInt($rangeInput.eq(1).val(), 10);

        $range.css("left", (newMin / $rangeInput.eq(0).attr("max")) * 100 + "%");
        $range.css("right", 100 - (newMax / $rangeInput.eq(1).attr("max")) * 100 + "%");
      }
    }, 200);
  }, 200);
}

$(document).on("click", ".active-facets__button-remove", function () {
  setTimeout(function () {
    var $rangeInput = $(".range-input input");
    var $priceInput = $(".price-input input");
    var $range = $(".slider .progress");

    let minVal = parseInt($rangeInput.eq(0).attr("min"), 10) || 0;
    let maxVal = parseInt($rangeInput.eq(1).attr("max"), 10) || 1000;

    setTimeout(function(){
      if ($(".slider .progress").length > 0) {
        let minVal = parseInt($rangeInput.eq(0).val(), 10);
        let maxVal = parseInt($rangeInput.eq(1).val(), 10);

        $(".slider .progress").css("left", (minVal / $rangeInput.eq(0).attr("max")) * 100 + "%");
        $(".slider .progress").css("right", 100 - (maxVal / $rangeInput.eq(1).attr("max")) * 100 + "%");
      }
    },500);
    initializeLoadMorePagination();
  }, 300); // use 500ms, adjust if needed based on Shopify's update speed

});
// Call initialize on page load
$(document).ready(function () {
  initializeProgress();
});

function filterExludePrice(htmlform){
  if(jQuery('.main_collection_container').hasClass('filter-versions')){
    var getminPrice = parseInt($priceInput.eq(0).val(), 10);
    var getmaxPrice = parseInt($priceInput.eq(1).val(), 10);
    if(defaultMin == getminPrice || defaultMax == getmaxPrice){
      const $form = htmlform.closest('form');
      const formData = $form.serializeArray();
      console.log("formData",formData);
      // Remove price-related params
      const excludeKeys = [
        'filter.v.price',
        'filter.v.price.gte',
        'filter.v.price.lte'
      ];

      // Filter out unwanted params
      const filteredParams = formData.filter(param => {
        return !excludeKeys.some(key => param.name.includes(key));
      });

      // Build the clean query string
      const queryString = $.param(filteredParams);
      const url = `${window.location.pathname}?${queryString}`;

      console.log("urlll",url);
      // Update the browser URL without reloading
      setTimeout(function(){
        history.replaceState(null, '', url);
      },800);
    }
  }
}

$(document).on('input', '.price-input input', function () {
  const $rangeInput = $(".range-input input");
  const $priceInput = $(".price-input input");
  const $range = $(".slider .progress");

  let minPrice = parseInt($priceInput.eq(0).val(), 10);
  let maxPrice = parseInt($priceInput.eq(1).val(), 10);

  if (maxPrice - minPrice >= priceGap && maxPrice <= parseInt($rangeInput.eq(1).attr("max"), 10)) {
    if ($(this).hasClass("input-min")) {
      $rangeInput.eq(0).val(minPrice);
      $("#Mobile-Filter-Price-GTE").val(minPrice);
      $range.css("left", (minPrice / $rangeInput.eq(0).attr("max")) * 100 + "%");
    } else {
      $rangeInput.eq(1).val(maxPrice);
      $("#Mobile-Filter-Price-LTE").val(maxPrice);
      $range.css("right", 100 - (maxPrice / $rangeInput.eq(1).attr("max")) * 100 + "%");
    }
  }
});

$(document).on('input', '.range-input input', function () {
  const $rangeInput = $(".range-input input");
  const $priceInput = $(".price-input input");
  const $range = $(".slider .progress");

  let minVal = parseInt($rangeInput.eq(0).val(), 10);
  let maxVal = parseInt($rangeInput.eq(1).val(), 10);

  if (maxVal - minVal < priceGap) {
    if ($(this).hasClass("range-min")) {
      $rangeInput.eq(0).val(maxVal - priceGap).trigger("input");
    } else {
      $rangeInput.eq(1).val(minVal + priceGap).trigger("input");
    }
  } else {
    $priceInput.eq(0).val(minVal);
    $priceInput.eq(1).val(maxVal);
    $range.css("left", (minVal / $rangeInput.eq(0).attr("max")) * 100 + "%");
    $range.css("right", 100 - (maxVal / $rangeInput.eq(1).attr("max")) * 100 + "%");
  }
});
//FILTER PRICE RANGE PICKER JS END

/********************** COLLECTION PAGE VISIT AND AFTER CLICK PRODUCT TO SET PREVIOUS AND NEXT PRODUCT LINK DETAILS PAGE JS START ************************/
//collection page visit to set previous and next link
$(document).ready(function () {
    if($('.page-collection').find('#ProductGridContainer').length > 0) {
      localStorage.setItem("prevProduct", '');
      localStorage.setItem("nextProduct", '');
      localStorage.setItem("collectionName", '');
      localStorage.setItem("currentProduct", '');

      let productLinks = $('#ProductGridContainer').find(".card-information__wrapper a.full-unstyled-link");
      let productArray = [];

      // Store all product URLs in an array
      productLinks.each(function () {
          productArray.push($(this).attr("href"));
      });
      //console.log("productArray",productArray);
      // Save product URLs in localStorage
      localStorage.setItem("productList", JSON.stringify(productArray));
      let prevProduct = window.location.href;
      localStorage.setItem("prevProduct", prevProduct);
      let collectionName = '';
      if (jQuery('.collection-hero').find('.collection-hero__title').length > 0) {
          collectionName = jQuery('.collection-hero').find('.collection-hero__title').text();
      }
      //console.log("collectionName",collectionName);
      localStorage.setItem("collectionName", collectionName);
        // Detect product click and save previous & next product links
      jQuery(document).on('click', '#ProductGridContainer .card-wrapper a', function () {
          let clickedProduct = $(this).attr("href");
          //console.log("clickedProduct",clickedProduct);
          let storedProducts = JSON.parse(localStorage.getItem("productList")) || [];
          let productIndex = storedProducts.indexOf(clickedProduct);
          let nextProduct = productIndex < storedProducts.length - 1 ? storedProducts[productIndex + 1] : null;
          localStorage.setItem("nextProduct", nextProduct);

      });
    } else if (jQuery('body').hasClass('template-index')) {
        localStorage.setItem("prevProduct", '');
        localStorage.setItem("nextProduct", '');
        localStorage.setItem("collectionName", '');
        localStorage.setItem("currentProduct", '');
    }
});

// Product details page: Get previous and next links
$(document).ready(function () {
  //console.log("checkkkk",window.getComputedStyle(document.querySelector('.breadcrumb-wrapper')).display);
  if(jQuery('.breadcrumb-wrapper').is(':visible')) {
      let productArray = JSON.parse(localStorage.getItem("productList")) || [];
      let currentProduct = localStorage.getItem("currentProduct");
      let prevProduct = localStorage.getItem("prevProduct");

      let nextProduct = localStorage.getItem("nextProduct");
      let collectName = localStorage.getItem("collectionName");
      //console.log("prevProduct",prevProduct,collectName);
      let productIndex = productArray.indexOf(currentProduct);
      let newNextProduct = productIndex < productArray.length - 1 ? productArray[productIndex + 1] : null;

      let objlinkhtml = jQuery('.breadcrumb-wrapper').find('.breadcrumbs-one');
      let objlinkhtml1 = jQuery('.breadcrumb-wrapper').find('.breadcrumbs-two');
      let flagnav = 0;
      if(collectName!="" && collectName!=undefined){
        collectName=collectName.replace('Collection:','');
      }
      // Set Previous Product Link
      if(jQuery('.breadcrumb-wrapper').find('.breadcrumbs-three').is(':visible')){
       if(prevProduct){
         var targetHref = prevProduct.replace(/^.*\/\/[^\/]+/, '');
         var cleanUrl = targetHref.split('?')[0];
         jQuery('.breadcrumb-wrapper .collection-list-wrapper li.collection-name').each(function () {
            var $li = jQuery(this);
            var $anchor = $li.find('a');
            var anchorHref = $anchor.attr('href')?.split('?')[0]; // remove query string
            //console.log("anchorHref",anchorHref,cleanUrl);
            if (anchorHref === cleanUrl) {
              console.log("Match found for:", anchorHref);
              jQuery('.breadcrumb-wrapper .collection-list-wrapper li').removeClass('active');
              $li.addClass('active');

              // Move matched <li> to very top of the list (before .collection-title)
              $li.prependTo('.collection-list-wrapper');

              return false;
            }
         });
       }
      }else if (prevProduct) {
          if (collectName !== "") {

            objlinkhtml.find(".prev-product .collection-title").text(collectName);
            objlinkhtml1.find(".prev-product .collection-title").text(collectName);
          } else {
              let cleanUrl = prevProduct.split('?')[0];
              let lastSegment = cleanUrl.split('/').filter(Boolean).pop();

              if (lastSegment) {
                  let upperCaseName = decodeURIComponent(lastSegment).replace(/-/g, ' ').toUpperCase();
                  objlinkhtml.find(".prev-product .collection-title").text(upperCaseName);
                objlinkhtml1.find(".prev-product .collection-title").text(upperCaseName);
              }
          }
          objlinkhtml.find(".prev-product").attr("href", prevProduct);
          objlinkhtml1.find(".prev-product").attr("href", prevProduct);
      } else {
          //objlinkhtml.find(".prev-product").hide();
          flagnav = 1;
      }

      // Set Next Product Link
      if(nextProduct) {
        objlinkhtml.find(".next-product").attr("href", nextProduct);
        objlinkhtml1.find(".next-product").attr("href", nextProduct);
      }else{
        //objlinkhtml.find(".next-product").hide();
        flagnav = 1;
      }

      if (flagnav === 0) {
          jQuery('.page-product').find('.nextprev-wrap').addClass('active-wrap');
      }

      // Update current product and next product on click
      jQuery(document).on("click", ".next-product", function () {
          localStorage.setItem("currentProduct", nextProduct);
          let nextIndex = productArray.indexOf(nextProduct);
          let newNextProduct = nextIndex < productArray.length - 1 ? productArray[nextIndex + 1] : null;
          localStorage.setItem("nextProduct", newNextProduct);
      });
  }
});
/********************** COLLECTION PAGE VISIT AND AFTER CLICK PRODUCT TO SET PREVIOUS AND NEXT PRODUCT LINK DETAILS PAGE JS END ************************/

/***************** BUNDLE PACK OFFER NEW -- START *******************/

jQuery(document).ready(function(){

  // Simulate user selection for initial state - moved to after handlers are set up
  setTimeout(function() {
    console.log('[DEBUG] ===== AUTO-SELECTION STARTING =====');

    if($(".protein_kit_btn").length > 0) {
      // DEBUG: Log all subscription/onetime radios
      console.log('[DEBUG] All recharge_custom radios:', document.querySelectorAll('input[name="recharge_custom"]'));
      console.log('[DEBUG] Recharge Widget rc-radio1:', document.querySelector('input#rc-radio1'));
      console.log('[DEBUG] Recharge Widget rc-radio2:', document.querySelector('input#rc-radio2'));
      console.log('[DEBUG] purchaseOption radios:', document.querySelectorAll('input[name="purchaseOption"]'));

      // Log current states
      var customSubscriptionChecked = document.querySelector('input[name="recharge_custom"][value="subscribe"]:checked');
      var customOnetimeChecked = document.querySelector('input[name="recharge_custom"][value="onetime"]:checked');
      var customOnetimeChecked2 = document.querySelector('input[name="recharge_custom"][value="on"]:checked');
      var rc1Checked = document.querySelector('input#rc-radio1:checked');
      var rc2Checked = document.querySelector('input#rc-radio2:checked');
      var purchaseOptionSubscriptionChecked = document.querySelector('input[name="purchaseOption"][value="subscription"]:checked');
      var purchaseOptionOnetimeChecked = document.querySelector('input[name="purchaseOption"][value="onetime"]:checked');

      console.log('[DEBUG] Custom subscription checked:', !!customSubscriptionChecked);
      console.log('[DEBUG] Custom onetime checked:', !!customOnetimeChecked);
      console.log('[DEBUG] Custom onetime (value="on") checked:', !!customOnetimeChecked2);
      console.log('[DEBUG] RC-radio1 (Recharge subscription) checked:', !!rc1Checked);
      console.log('[DEBUG] RC-radio2 (Recharge onetime) checked:', !!rc2Checked);
      console.log('[DEBUG] purchaseOption subscription checked:', !!purchaseOptionSubscriptionChecked);
      console.log('[DEBUG] purchaseOption onetime checked:', !!purchaseOptionOnetimeChecked);

      // CHECK: Don't override if Recharge Widget already has onetime selected (for AB tests)
      var rechargeOnetimeSelected = document.querySelector('input#rc-radio2:checked, input[name="purchaseOption"][value="onetime"]:checked');
      console.log('[DEBUG] Recharge onetime selected (rc-radio2 OR purchaseOption[onetime]):', !!rechargeOnetimeSelected);

      $(".protein_kit_btn").first().trigger("click");

      // EJHPN - 02-03-26
      // Only auto-select subscription if Recharge widget doesn't have onetime already selected
      // if (!rechargeOnetimeSelected) {
      //   console.log('[DEBUG] No Recharge onetime found - auto-selecting subscription');
      //   $("[name='recharge_custom']").first().trigger("change");
      // } else {
      //   console.log('[DEBUG] Recharge onetime IS selected - NOT forcing subscription');
      // }

      // EJHPN - 02-03-26
      // ==========================================================
      // HPN: Protein Offer default frequency override
      // If product ID is 7193611337967 => default Step 3 to ONE TIME
      // ==========================================================
      var currentProductIdEl = document.querySelector('form[action^="/cart/add"] [name="id"][data-productid]');
      var currentProductId = currentProductIdEl ? String(currentProductIdEl.getAttribute('data-productid') || '') : '';
      console.log('[DEBUG] Current product id detected:', currentProductId);

      // ==========================================================
      // HPN: Products that should DEFAULT Step 3 to ONE TIME
      // ==========================================================
      var HPN_DEFAULT_ONETIME_PRODUCT_IDS = ['8924495872239'];
      var shouldDefaultOneTime = (HPN_DEFAULT_ONETIME_PRODUCT_IDS.indexOf(currentProductId) !== -1);
      console.log('[DEBUG] shouldDefaultOneTime:', shouldDefaultOneTime);


      function forceOneTimeSelection() {
        console.log('[DEBUG] Forcing ONE TIME selection for default-one-time product:', currentProductId);

        // If user already interacted, do NOT override their choice
        if (window.__HPN_PROTEIN_FREQ_USER_SET === true) {
          console.log('[DEBUG] User already set frequency manually - not overriding');
          return;
        }

        function clearSellingPlanInputs() {
          // Clear any selling_plan inputs so Recharge can't re-assert subscription via hidden value
          document.querySelectorAll('form[action^="/cart/add"] [name="selling_plan"]').forEach(function (sp) {
            if (sp && sp.value) {
              sp.value = '';
              sp.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }

        function clickOneTimeEverywhere() {
          // 1) Custom protein-offer frequency radios (your custom UI)
          var customOneTime =
            document.querySelector('input[name="recharge_custom"][value="onetime"]') ||
            document.querySelector('input[name="recharge_custom"][value="on"]');
          if (customOneTime) {
            customOneTime.checked = true;
            customOneTime.dispatchEvent(new Event('change', { bubbles: true }));
            customOneTime.click && customOneTime.click();
          }

          // 2) Recharge widget radios (common IDs)
          var rcOnetime = document.querySelector('input#rc-radio2');
          if (rcOnetime) {
            rcOnetime.checked = true;
            rcOnetime.dispatchEvent(new Event('change', { bubbles: true }));
            rcOnetime.click && rcOnetime.click();
          }

          // 3) Alternate purchase option radios some templates use
          var purchaseOnetime = document.querySelector('input[name="purchaseOption"][value="onetime"]');
          if (purchaseOnetime) {
            purchaseOnetime.checked = true;
            purchaseOnetime.dispatchEvent(new Event('change', { bubbles: true }));
            purchaseOnetime.click && purchaseOnetime.click();
          }

          // 4) Also try clicking obvious One Time label/button targets
          var oneTimeLabel =
            document.querySelector('label[for="onetime"]') ||
            document.querySelector('label[for="one-time"]') ||
            document.querySelector('.onetime-radio') ||
            document.querySelector('[data-purchase-type="onetime"]');
          if (oneTimeLabel && oneTimeLabel.click) oneTimeLabel.click();

          // Always clear selling plan AFTER clicks
          clearSellingPlanInputs();
        }

        // Run immediately
        clickOneTimeEverywhere();

        // Keep enforcing for a short window because Recharge often re-renders after load
        var tries = 0;
        var maxTries = 30; // ~3 seconds at 100ms
        var lockInterval = setInterval(function () {
          tries++;

          // Stop if user manually chose something
          if (window.__HPN_PROTEIN_FREQ_USER_SET === true) {
            clearInterval(lockInterval);
            return;
          }

          // If subscription got re-selected, push it back to one-time
          var subSelected =
            document.querySelector('input#rc-radio1:checked') ||
            document.querySelector('input[name="purchaseOption"][value="subscription"]:checked') ||
            document.querySelector('input[name="recharge_custom"][value="subscribe"]:checked');

          if (subSelected) {
            console.log('[DEBUG] Recharge re-selected subscription - forcing One Time again');
            clickOneTimeEverywhere();
          } else {
            // Still clear selling_plan if it got repopulated silently
            clearSellingPlanInputs();
          }

          if (tries >= maxTries) clearInterval(lockInterval);
        }, 100);

        // Watch for Recharge DOM changes (re-render) and re-apply one-time
        var rcRoot =
          document.querySelector('.shopify-block.recharge-subscription-widget') ||
          document.querySelector('.recharge-subscription-widget') ||
          document.querySelector('.rc-container') ||
          document.body;

        if (rcRoot && window.MutationObserver) {
          var mo = new MutationObserver(function () {
            if (window.__HPN_PROTEIN_FREQ_USER_SET === true) return;
            // Light-touch: just clear selling plan + ensure onetime if subscription pops back
            var subSelected =
              document.querySelector('input#rc-radio1:checked') ||
              document.querySelector('input[name="purchaseOption"][value="subscription"]:checked') ||
              document.querySelector('input[name="recharge_custom"][value="subscribe"]:checked');

            if (subSelected) {
              clickOneTimeEverywhere();
            } else {
              clearSellingPlanInputs();
            }
          });

          mo.observe(rcRoot, { subtree: true, childList: true, attributes: true });
          setTimeout(function () { try { mo.disconnect(); } catch(e){} }, 5000); // auto-stop after 5s
        }
      }

      // If this product should default to One Time, enforce it once on load
      if (shouldDefaultOneTime) {
        forceOneTimeSelection();
      }

      // If the user clicks/toggles frequency themselves, stop auto-overriding
      document.addEventListener('change', function (e) {
        if (!e || !e.target) return;

        // If promo logic is forcing One Time, do not mark as "user intent"
        if (window.__HPN_PROTEIN_PROMO_FORCING === true) return;

        var n = e.target.name;
        var id = e.target.id;

        // Any of these means the user interacted with purchase choice
        if (n === 'recharge_custom' || n === 'purchaseOption' || id === 'rc-radio1' || id === 'rc-radio2') {
          window.__HPN_PROTEIN_FREQ_USER_SET = true;
        }
      }, true);

      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('label, button, a, div') : null;
        if (!t) return;

        // If they click a Recharge option label, assume intent
        if (t.classList && (t.classList.contains('onetime-radio') || t.classList.contains('subscription-radio'))) {
          window.__HPN_PROTEIN_FREQ_USER_SET = true;
        }
      }, true);


      // Promo-lock behavior is handled inside protein-offer.liquid (DISCOUNT_VIDS logic).
      // Do NOT globally force One Time for these products here.
      if (!rechargeOnetimeSelected && !shouldDefaultOneTime) {
        console.log('[DEBUG] No Recharge onetime found - auto-selecting subscription');
        $("[name='recharge_custom']").first().trigger("change");
      } else {
        console.log('[DEBUG] Recharge onetime IS selected OR default-one-time product - NOT forcing subscription');
      }



      $("[name='kit']").first().prop("checked", true).trigger("change");
      $(".protein_flavors select").each(function() {
        $(this).prop("selectedIndex", 0).trigger("change");
      });
    }

    console.log('[DEBUG] ===== AUTO-SELECTION COMPLETE =====');
  }, 100);

  var fullUrl = window.location.href;
  var pathSegments = window.location.pathname.split('/').filter(Boolean);
  var interIds = setInterval(function(){
    if(jQuery('.rc-template__radio').find('.onetime-radio').length>0){
      var lastSegment = pathSegments[pathSegments.length - 1];
      if(lastSegment){
        let urlget = new URL(fullUrl);
        let params = new URLSearchParams(urlget);
        //console.log("lastsegment",lastSegment,params);
        if(lastSegment=='the-no-limit-bundle-creatine' && params.has('convert_action')==false){
          if(jQuery('.page-product').find('.shopify-block.recharge-subscription-widget').length>0){
            jQuery('.page-product').find('.shopify-block.recharge-subscription-widget').hide();
          }
          jQuery('.rc-template__radio').find('.onetime-radio').trigger("click");
          const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);
          clearInterval(interIds);
        }
      }
    }
  },200);
});


function getUrlBaseSegement(){
  var fullUrl = window.location.href;
  var pathSegments = window.location.pathname.split('/').filter(Boolean);
  var lastSegment = pathSegments[pathSegments.length - 1];
  return lastSegment;
}

jQuery(document).ready(function(){
  var fullUrl = window.location.href;
  var pathSegments = window.location.pathname.split('/').filter(Boolean);
  var lastSegment = pathSegments[pathSegments.length - 1];
  var interIds = setInterval(function(){
    const urlParams = new URLSearchParams(window.location.search);
    const planids = urlParams.get('selling_plan');

    // ----------------------------------------------------------
    // HPN FIX: Do NOT auto-select subscription for Protein 7193611337967
    // even if URL has ?selling_plan=... (it will override One Time default)
    // ----------------------------------------------------------
    var currentProductIdEl = document.querySelector('form[action^="/cart/add"] [name="id"][data-productid]');
    var currentProductId = currentProductIdEl ? String(currentProductIdEl.getAttribute('data-productid') || '') : '';

    // If promo lock is active, do NOT auto-select subscription from URL params
    if (window.__HPN_PROTEIN_PROMO_LOCK === true) {
      clearInterval(interIds);
      return;
    }

    // if(lastSegment == 'lean-plant-protein' && planids!="" && planids!=undefined){
    // EJHPN
    if ((lastSegment === 'lean-plant-protein' || lastSegment === 'lean-plant-protein-3' || lastSegment === 'lean-plant-protein-2' || lastSegment ===  'lean-plant-protein-unicorn-milk-shake' || lastSegment === 'lean-plant-protein-vancc' || lastSegment === 'lean-plant-protein-chcss' || lastSegment === 'lean-plant-protein-latte' || lastSegment === 'lean-plant-protein-1') && planids !== "" && planids !== undefined) {

      if(jQuery('.protein_frequency').find('.pf_header_subscription').find('#subscribe').length>0){
        jQuery('.protein_frequency').find('.pf_header_subscription').find('.pf_header_subscription').eq(0).trigger('click');
        jQuery('.protein_frequency').find('.pf_header_subscription').find('.pf_subscription_label[for="subscribe"]').trigger('click');
        setTimeout(function(){
          var tooltipObject = jQuery('.shopify-block.recharge-subscription-widget').find('div.rc-tooltip');
          var tooltipName = tooltipObject.find('.how-it-works strong').text();
          var tooltipDescription = tooltipObject.find('.how-it-works').html().split('<br>')[1];
          tooltipDescription = tooltipDescription.trim();
          var tooltipAnchor = tooltipObject.find('.rc-tooltip__footer a').attr('href');
          var tooltipAnchorText = tooltipObject.find('.rc-tooltip__footer a').find('span').text();
          //console.log("tooltipAnchor",tooltipAnchorText);
          jQuery('.protein_frequency').find('.pf_subscription_popup .tooltip_title').text(tooltipName);
          jQuery('.protein_frequency').find('.pf_subscription_popup .description').text(tooltipDescription);
          jQuery('.protein_frequency').find('.pf_subscription_popup .powered-button').attr('href',tooltipAnchor);
          jQuery('.protein_frequency').find('.pf_subscription_popup .powered-button').text(tooltipAnchorText);
        },1000);
      }
      //price set for no limit bundle start
      var nobundlePrice = 0;
      if(jQuery('.protein_offer').find('[name="kit"]').length>0){
          nobundlePrice = jQuery('.protein__variants').find('#Option-5').find('option').attr('data-price');
      }
      if(nobundlePrice!=0 && jQuery('.protein_kit_options').find('.bundle_option.protein_kit_btn').length>0){
        setTimeout(function(){
          if(nobundlePrice!=0){
            jQuery('.protein_kit_options').find('.bundle_option.protein_kit_btn').find('.pk_sale_price').text(Shopify.formatMoney(nobundlePrice));
          }
        },200);
      }
      //price set for no limit bundle end
      clearInterval(interIds);
    }
  },1000);
});

// Simple click handler for offer products
// Since inline HPN script is disabled for offers, this will always run
jQuery(document).on('click','[name="add"]',function(e){
  console.log("[OFFER] === ADD TO CART BUTTON CLICKED ===");

  var clickedForm = this.closest ? this.closest('form') : null;
  var clickedFormId = clickedForm ? clickedForm.getAttribute('id') : '';
  if (clickedFormId && document.querySelector('[data-skio-subscriptions][data-form-id="' + clickedFormId + '"]')) {
    console.log("[OFFER] Skio subscriptions form detected - allowing Skio handler");
    return;
  }

  // Check if this is on an offer product page where we disabled the inline script
  var isOfferPage = jQuery('.protein_offer').length > 0;
  var isLegacyOffer = jQuery(this).hasClass('protein_offer_second') || jQuery(this).hasClass('protein_offer_third');
  var isBundle = jQuery('.product--details').hasClass('product_bundle_box');

  console.log("[OFFER] isOfferPage:", isOfferPage);
  console.log("[OFFER] isLegacyOffer:", isLegacyOffer);
  console.log("[OFFER] isBundle:", isBundle);

  // If not on offer page AND not legacy offer AND not bundle, let default handling work
  if (!isOfferPage && !isLegacyOffer && !isBundle) {
    console.log("[OFFER] Not an offer product - allowing default form submission");
    return; // Let default form submission handle
  }

  console.log("[OFFER] === OFFER DETECTED - WILL HANDLE ===");

  var objBtn=jQuery(this);
  console.log("[OFFER] Button element:", objBtn);
  console.log("[OFFER] Button classes:", objBtn.attr('class'));

  var variantId = jQuery(this).parent().parent('form').find('[name="id"]').val();
  var productId = jQuery(this).parent().parent('form').find('[name="id"]').attr('data-productid');
  var qunatity = parseInt(jQuery('.product__info-container').find('[name="quantity"]').val());
  var sellingId=0;

  console.log("[OFFER] Form variant ID:", variantId);
  console.log("[OFFER] Product ID:", productId);
  console.log("[OFFER] Quantity:", qunatity);

  if(jQuery(this).parent().parent('form').find('[name="selling_plan"]').length>0){
    sellingId = jQuery(this).parent().parent('form').find('[name="selling_plan"]').val();
    console.log("[OFFER] Form selling plan:", sellingId);
  }

  if($(this).hasClass('protein_offer_second') || $(this).hasClass('protein_offer_third')){
    console.log("[OFFER] Detected protein_offer_second or protein_offer_third");
    e.preventDefault();
    if ($(this).hasClass('loading')) return;
    $(this).attr('aria-disabled', true);
    $(this).addClass('loading');
    $(this).parent().find('.loading-overlay__spinner').removeClass('hidden');
    addLegacyOfferProducts(this);
  }
  else if($('.product--details').hasClass('product_bundle_box')){
    console.log("[OFFER] Detected product_bundle_box");
    var itemArr = []
    if($('.bundle_product_grid').hasClass('version_1')){
      itemArr.push({
        id: 43008263487727,
        quantity: 1
      });
    }
    else if($('.bundle_product_grid').hasClass('version_2')){

    }
    else if($('.bundle_product_grid').hasClass('version_3')){

    }
    itemArr.push({
      id: 43008263487727,
      quantity: 1
    });
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    console.log("[OFFER] itemArr:", itemArr);
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
       if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
          setTimeout(function(){
            if(jQuery('.add__custom_loader').length>0){
              if(objBtn.hasClass('loading')){
                objBtn.removeClass('loading');
              }
              if(objBtn.find('.loading-overlay__spinner').length>0){
                objBtn.find('.loading-overlay__spinner').addClass('hidden');
              }
              jQuery('.add__custom_loader').hide();
            }
          },3000);
         drawerOpen();
        } else{
          window.location.href = '/cart';
        }
      },
      error: function(response) {
          console.log("[OFFER] Error:", response);
      }
    });
  }
  else if($('.protein_offer').length > 0){
    console.log("[OFFER] Detected protein_offer");
    // Check if this is a two-pack bundle
    var kitActive = parseInt(jQuery('.protein_offer .protein_kit_options').find('.protein_kit_btn.active').find('[name="kit"]:checked').val());
    console.log("[OFFER] kitActive value:", kitActive);
    console.log("[OFFER] Is kitActive === 2?", kitActive === 2);

    // Prevent default form submission for ALL offer types (single, two-pack, bundle)
    e.preventDefault();
    console.log("[OFFER] Form submission prevented");

    if(kitActive === 2) {
      console.log("[OFFER] === TWO-PACK DETECTED ===");
    }

    if ($(this).hasClass('loading')) {
      console.log("[OFFER] Button already loading, returning");
      return;
    }
    $(this).attr('aria-disabled', true);
    $(this).addClass('loading');
    $(this).parent().find('.loading-overlay__spinner').removeClass('hidden');
    console.log("[OFFER] Loading state set");

    const props = getLineItemProperties();
    console.log("[OFFER] Line item properties:", props);
    addOfferProducts(qunatity, variantId, productId, props);
  }
  else if (isOfferPage) {
    // Fallback: if we determined it's an offer page but no specific handler matched,
    // still process it as a protein_offer
    console.log("[OFFER] Fallback: Processing as protein_offer (isOfferPage=true)");
    e.preventDefault();
    console.log("[OFFER] Form submission prevented (fallback)");

    if ($(this).hasClass('loading')) {
      console.log("[OFFER] Button already loading, returning");
      return;
    }
    $(this).attr('aria-disabled', true);
    $(this).addClass('loading');
    $(this).parent().find('.loading-overlay__spinner').removeClass('hidden');
    console.log("[OFFER] Loading state set (fallback)");

    const props = getLineItemProperties();
    console.log("[OFFER] Line item properties (fallback):", props);
    addOfferProducts(qunatity, variantId, productId, props);
  }
  else {
    console.log("[OFFER] No matching handler found");
    //if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
      //addItemCart(1,variantId,sellingId);
  }
});

function HPN_getOfferPurchaseType() {
  // PRIORITY: Check for explicit "onetime" FIRST before subscription
  // This prevents subscription from being selected by default
  // 1) Your custom UI (recharge_custom) - onetime BEFORE subscribe
  // 2) Then Recharge widget radios - rc-radio2 (onetime) BEFORE rc-radio1 (subscribe)
  // 3) Then purchaseOption radios - onetime BEFORE subscription
  // 4) Then active label fallback - onetime BEFORE subscribe
  // Default: onetime

  try {
    // CHECK CUSTOM UI - ONETIME FIRST
    var customChecked = document.querySelector('input[name="recharge_custom"][value="onetime"]:checked');
    if (customChecked && customChecked.value) return 'onetime';

    customChecked = document.querySelector('input[name="recharge_custom"][value="subscribe"]:checked');
    if (customChecked && customChecked.value) return 'subscribe';

    // CHECK RECHARGE WIDGET - ONETIME FIRST (rc-radio2 is the one-time option)
    if (document.querySelector('input#rc-radio2:checked')) return 'onetime';
    if (document.querySelector('input#rc-radio1:checked')) return 'subscribe';

    // CHECK PURCHASE OPTION - ONETIME FIRST
    if (document.querySelector('input[name="purchaseOption"][value="onetime"]:checked')) return 'onetime';
    if (document.querySelector('input[name="purchaseOption"][value="subscription"]:checked')) return 'subscribe';

    // Fallback: Recharge sometimes toggles "active" label without syncing input immediately
    // CHECK ONETIME FIRST
    if (document.querySelector('.rc-template__radio label.rc-radio--active.onetime-radio')) return 'onetime';
    if (document.querySelector('.rc-template__radio label.rc-radio--active.subscription-radio')) return 'subscribe';
  } catch (e) {}

  return 'onetime';
}


function getLineItemProperties() {
  const props = {};
  document.querySelectorAll('product-form [name^="properties["]').forEach(input => {
    const key = input.name.replace('properties[','').replace(']','');
    const value = input.value.trim();
    if (value !== "") props[key] = value;
  });
  return props;
}
function addOfferProducts(qty, variantId, productId, properties = {}) {
  console.log("[OFFER] ===== addOfferProducts STARTING =====");
  console.log("[OFFER] qty:", qty, "variantId:", variantId, "productId:", productId);

  // DEBUG: Log Recharge Widget state at time of click
  console.log('[OFFER] ===== RECHARGE WIDGET DEBUG AT CLICK =====');
  var rc1Checked = document.querySelector('input#rc-radio1:checked');
  var rc2Checked = document.querySelector('input#rc-radio2:checked');
  var purchaseOptionSubscriptionChecked = document.querySelector('input[name="purchaseOption"][value="subscription"]:checked');
  var purchaseOptionOnetimeChecked = document.querySelector('input[name="purchaseOption"][value="onetime"]:checked');
  console.log('[OFFER] RC-radio1 (Recharge subscription) checked:', !!rc1Checked);
  console.log('[OFFER] RC-radio2 (Recharge onetime) checked:', !!rc2Checked);
  console.log('[OFFER] purchaseOption[subscription] checked:', !!purchaseOptionSubscriptionChecked);
  console.log('[OFFER] purchaseOption[onetime] checked:', !!purchaseOptionOnetimeChecked);

  // DEBUG: Log custom radios
  console.log('[OFFER] ===== CUSTOM RADIOS DEBUG AT CLICK =====');
  var customSubscriptionChecked = document.querySelector('input[name="recharge_custom"][value="subscribe"]:checked');
  var customOnetimeChecked = document.querySelector('input[name="recharge_custom"][value="onetime"]:checked');
  console.log('[OFFER] Custom subscribe checked:', !!customSubscriptionChecked);
  console.log('[OFFER] Custom onetime checked:', !!customOnetimeChecked);
  console.log('[OFFER] All recharge_custom inputs:', jQuery('input[name="recharge_custom"]').map((i, el) => ({id: el.id, value: el.value, checked: el.checked})));
  console.log('[OFFER] ===== END DEBUG AT CLICK =====');

  console.log("[OFFER] === addOfferProducts CALLED ===");
  console.log("[OFFER] qty:", qty);
  console.log("[OFFER] variantId:", variantId);
  console.log("[OFFER] productId:", productId);
  console.log("[OFFER] properties:", properties);

  var purchaseType = HPN_getOfferPurchaseType();
  console.log("[OFFER] Purchase type (SOURCE OF TRUTH):", purchaseType);

  var itemArr = [];
  var kitActive = parseInt(jQuery('.protein_offer .protein_kit_options')
    .find('.protein_kit_btn.active')
    .find('[name="kit"]:checked')
    .val());

  console.log("[OFFER] kitActive in addOfferProducts:", kitActive);

  if (kitActive === 1 && variantId && !isNaN(variantId) && qty > 0) {
    console.log("[OFFER] Processing SINGLE PACK (kitActive === 1)");
    var sellingId = parseInt(jQuery('.protein_offer .protein_kit_options').find('.protein_kit_btn.active').attr('data-selling-id'));

    var getSubscription = purchaseType;
    console.log("[OFFER] Single pack - purchaseType:", getSubscription);

    console.log("[OFFER] Single pack - sellingId:", sellingId);
    console.log("[OFFER] Single pack - getSubscription:", getSubscription);

    // EXTRA DEBUG: What is the actual HTML showing?
    console.log('[OFFER] HTML of protein_frequency:', jQuery('.protein_frequency').html().substring(0, 500));

    // Check what the Recharge Widget is showing
    var rcWidget = jQuery('.rc-template__radio');
    if (rcWidget.length > 0) {
      console.log('[OFFER] Recharge Widget found - checking which radio is active');
      var rcActive = rcWidget.find('label.rc-radio--active, label.rc-radio.rc-radio--active');
      console.log('[OFFER] Active label HTML:', rcActive.html().substring(0, 200));
    }

    if(getSubscription == 'subscribe' && sellingId!=undefined && sellingId!=""){
      itemArr.push({
        id: parseInt(variantId),
        quantity: qty,
        properties: properties,
        selling_plan:sellingId
      });
      console.log("[OFFER] Single pack with subscription added");
    }else{
      itemArr.push({
        id: parseInt(variantId),
        quantity: qty,
        properties: properties
      });
      console.log("[OFFER] Single pack without subscription added");
    }
  }

  // Handle Two-Pack (kitActive === 2)
  if (kitActive === 2) {
    console.log("[OFFER] === PROCESSING TWO-PACK ===");

    var getSubscription = purchaseType;
    console.log("[OFFER] Two-pack - purchaseType:", getSubscription);

    console.log("[OFFER] Two-pack - getSubscription:", getSubscription);

    // Get the selected variants from Option-1 and Option-2
    var firstVariantSelect = jQuery('.protein_flavors.double_flavors #Option-1');
    console.log("[OFFER] firstVariantSelect element:", firstVariantSelect);
    console.log("[OFFER] firstVariantSelect length:", firstVariantSelect.length);

    var firstVariantId = firstVariantSelect.length > 0 ? parseInt(firstVariantSelect.val()) : null;
    console.log("[OFFER] First variant ID from select:", firstVariantId);
    console.log("[OFFER] First variant select HTML:", firstVariantSelect.prop('outerHTML').substring(0, 200));

    var secondVariantSelect = jQuery('.protein_flavors.double_flavors #Option-2');
    console.log("[OFFER] secondVariantSelect element:", secondVariantSelect);
    console.log("[OFFER] secondVariantSelect length:", secondVariantSelect.length);

    var secondVariantId = secondVariantSelect.length > 0 ? parseInt(secondVariantSelect.val()) : null;
    console.log("[OFFER] Second variant ID from select:", secondVariantId);
    console.log("[OFFER] Second variant select HTML:", secondVariantSelect.prop('outerHTML').substring(0, 200));

    if (firstVariantId && secondVariantId) {
      console.log("[OFFER] Both variant IDs exist, proceeding...");
      // Get selling plan IDs from the selected options
      var firstSellingPlanId = null;
      var secondSellingPlanId = null;

      if(getSubscription == 'subscribe') {
        console.log("[OFFER] Subscription detected, extracting selling plan IDs...");
        // Get selling plan ID from first variant's selected option
        var firstSelectedOption = firstVariantSelect.find('option:selected');
        console.log("[OFFER] First selected option:", firstSelectedOption);
        console.log("[OFFER] First selected option HTML:", firstSelectedOption.prop('outerHTML'));
        firstSellingPlanId = firstSelectedOption.attr('data-selling-plan-id') ? parseInt(firstSelectedOption.attr('data-selling-plan-id')) : null;
        console.log("[OFFER] First selling plan ID:", firstSellingPlanId);

        // Get selling plan ID from second variant's selected option
        var secondSelectedOption = secondVariantSelect.find('option:selected');
        console.log("[OFFER] Second selected option:", secondSelectedOption);
        console.log("[OFFER] Second selected option HTML:", secondSelectedOption.prop('outerHTML'));
        secondSellingPlanId = secondSelectedOption.attr('data-selling-plan-id') ? parseInt(secondSelectedOption.attr('data-selling-plan-id')) : null;
        console.log("[OFFER] Second selling plan ID:", secondSellingPlanId);
      }

      // Add first variant
      if(getSubscription == 'subscribe' && firstSellingPlanId){
        console.log("[OFFER] Adding first variant with subscription - ID:", firstVariantId, "Plan:", firstSellingPlanId);
        itemArr.push({
          id: firstVariantId,
          quantity: 1,
          properties: {
            "__type": "two_pack"
          },
          selling_plan: firstSellingPlanId
        });
      }else{
        console.log("[OFFER] Adding first variant one-time - ID:", firstVariantId);
        itemArr.push({
          id: firstVariantId,
          quantity: 1,
          properties: {
            "__type": "two_pack"
          }
        });
      }

      // Add second variant
      if(getSubscription == 'subscribe' && secondSellingPlanId){
        console.log("[OFFER] Adding second variant with subscription - ID:", secondVariantId, "Plan:", secondSellingPlanId);
        itemArr.push({
          id: secondVariantId,
          quantity: 1,
          properties: {
            "__type": "two_pack"
          },
          selling_plan: secondSellingPlanId
        });
      }else{
        console.log("[OFFER] Adding second variant one-time - ID:", secondVariantId);
        itemArr.push({
          id: secondVariantId,
          quantity: 1,
          properties: {
            "__type": "two_pack"
          }
        });
      }
      console.log("[OFFER] itemArr after two-pack processing:", itemArr);
    } else {
      console.log("[OFFER] ERROR: Missing variant IDs. First:", firstVariantId, "Second:", secondVariantId);
    }
  }

  console.log("[OFFER] itemArr before packwiseFreeGift:", itemArr);

  // Add your gift products (if needed)
  packwiseFreeGift(itemArr, variantId, productId, properties);

  // HARD SAFETY: If UI is One Time, NEVER allow selling_plan to slip through
  if (purchaseType !== 'subscribe') {
    itemArr.forEach(function (it) {
      if (it && it.selling_plan) delete it.selling_plan;
    });
    console.log("[OFFER] Stripped selling_plan from all items (One Time selected).");
  }

  var filteredItems = itemArr.filter(item =>
    item.id && !isNaN(item.id) && item.quantity > 0
  );
  console.log("[OFFER] filteredItems:", filteredItems);

  if (filteredItems.length === 0) {
    console.warn("[OFFER] No valid items to add to cart.");
    return;
  }

  if(jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').length>0){
    jQuery('.product_buybutton_block').find('.product-form__submit').addClass('loading');
    jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').removeClass('hidden');
  }

  $.getJSON('/cart.js', function(cart) {
    console.log("[OFFER] Current cart:", cart);
    let freeGiftItems = [];

    cart.items.forEach(function(item) {
      if (item.properties && item.properties.__freegift && !freeGiftItems.includes(item.variant_id)) {
        freeGiftItems.push(item.variant_id);
      }
    });
    console.log("[OFFER] freeGiftItems:", freeGiftItems);

    var formData = new FormData();
    var validItemCount = 0;

    filteredItems.forEach((item, index) => {
      var variantIDs = parseInt(item.id);
      console.log("[OFFER] Processing item", index, '- ID:', variantIDs, '- Full item:', item);

      if(jQuery.inArray(variantIDs, freeGiftItems) == -1) {
        console.log("[OFFER] Item', index, 'is valid, adding to FormData");
        formData.append(`items[${index}][id]`, variantIDs);
        formData.append(`items[${index}][quantity]`, item.quantity);
        console.log("[OFFER] Added items[${index}][id] =", variantIDs);
        console.log("[OFFER] Added items[${index}][quantity] =", item.quantity);

        if (item.selling_plan) {
          formData.append(`items[${index}][selling_plan]`, parseInt(item.selling_plan));
          console.log("[OFFER] Added items[${index}][selling_plan] =", item.selling_plan);
        }
        if (item.properties && typeof item.properties === 'object') {
          Object.keys(item.properties).forEach(function (key) {
            formData.append(`items[${index}][properties][${key}]`, item.properties[key]);
            console.log("[OFFER] Added items[${index}][properties][${key}] =", item.properties[key]);
          });
        }
        validItemCount++;
      } else {
        console.log("[OFFER] Item', index, 'is a free gift, skipping");
      }
    });

    console.log("[OFFER] validItemCount:", validItemCount);

    if (validItemCount === 0) {
      console.warn("[OFFER] No valid items to add to cart after filtering free gifts.");
      if(jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').length>0){
        jQuery('.product_buybutton_block').find('.product-form__submit').removeClass('loading');
        jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').addClass('hidden');
      }
      return;
    }

    console.log("[OFFER] === SENDING TO /cart/add.js ===");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function (cart) {
        console.log("[OFFER] SUCCESS - Cart updated:", cart);
        if (window.updateConvertAttributes) window.updateConvertAttributes();
        if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
          console.log("[OFFER] Opening cart drawer");
          setTimeout(function(){
            if(jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').length>0){
              jQuery('.product_buybutton_block').find('.product-form__submit').removeClass('loading');
              jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').addClass('hidden');
            }
          },3000);
          drawerOpen();
        }else{
          console.log("[OFFER] Redirecting to cart");
          setTimeout(function(){
            window.location.href = '/cart';
          },2500);
        }
      },
      error: function (response) {
        console.error("[OFFER] ERROR - Response:", response);
        if(jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').length>0){
          jQuery('.product_buybutton_block').find('.product-form__submit').removeClass('loading');
          jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').addClass('hidden');
        }
      }
    });
  });
}

function addLegacyOfferProducts(submitButton) {
  let isSubscription = (HPN_getOfferPurchaseType() === 'subscribe');
  if(submitButton.classList.contains('protein_offer_second')){
    let fistProteinSelect = document.getElementById("Option-1");
    let fistProteinId = fistProteinSelect ? parseInt(fistProteinSelect.value) : null;
    let firstSelectedOption = fistProteinSelect ? fistProteinSelect.options[fistProteinSelect.selectedIndex] : null;
    let firstSellingPlanValue = firstSelectedOption ? parseInt(firstSelectedOption.getAttribute('data-selling-plan-id')) || 0 : 0;

    let secondProteinSelect = document.getElementById("Option-2");
    let secondProteinId = secondProteinSelect ? parseInt(secondProteinSelect.value) : null;
    let secondSelectedOption = secondProteinSelect ? secondProteinSelect.options[secondProteinSelect.selectedIndex] : null;
    let secondSellingPlanValue = secondSelectedOption ? parseInt(secondSelectedOption.getAttribute('data-selling-plan-id')) || 0 : 0;

    let activeKitSellingPlanValue = parseInt(
      jQuery('.protein_offer .protein_kit_options .protein_kit_btn.active').attr('data-selling-id')
    ) || 0;

    let rechargeSellingPlanInput = document.querySelector('input[name="selling_plan"]');
    let rechargeSellingPlanValue = rechargeSellingPlanInput ? parseInt(rechargeSellingPlanInput.value) || 0 : 0;

    firstSellingPlanValue = firstSellingPlanValue || activeKitSellingPlanValue || rechargeSellingPlanValue;
    secondSellingPlanValue = secondSellingPlanValue || activeKitSellingPlanValue || rechargeSellingPlanValue;

    // IMPORTANT:
    // 2-pack subscription should use ONE shared selling plan for BOTH items.
    // This prevents only one protein from getting the 20% plan if one dropdown option is missing data-selling-plan-id.
    let twoPackSellingPlanValue = activeKitSellingPlanValue || firstSellingPlanValue || secondSellingPlanValue || rechargeSellingPlanValue;

    const items = [
      {
        id: fistProteinId,
        quantity: 1,
        properties: {
          "__type": "two_pack"
        }
      },
      {
        id: secondProteinId,
        quantity: 1,
        properties: {
          "__type": "two_pack"
        }
      },
    ];

    // Add the same 2-pack selling plan to BOTH items if subscription is selected
    if (isSubscription && twoPackSellingPlanValue) {
      items.forEach(function (item) {
        item.selling_plan = twoPackSellingPlanValue;
      });
    }

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    };

    fetch('/cart/add.js', config)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          // Handle error, perhaps show message
          return;
        }

        if (window.updateConvertAttributes) window.updateConvertAttributes();
        if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
          setTimeout(function(){
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            submitButton.parentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
          },3000);
          drawerOpen();
        }else{
          window.location.href = '/cart';
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.parentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
  else if(submitButton.classList.contains('protein_offer_third')){
    let sellingPlanValue = 0;
    if (isSubscription) {
      sellingPlanValue = parseInt(document.querySelector('input[name="selling_plan"]').value) || 0;
    }
    let fistProteinSelect = document.getElementById("Option-3");
    let fistProteinId = fistProteinSelect ? parseInt(fistProteinSelect.value) : null;

    let secondProteinSelect = document.getElementById("Option-4");
    let secondProteinId = secondProteinSelect ? parseInt(secondProteinSelect.value) : null;

    let thirdProteinSelect = document.getElementById("Option-5");
    let thirdProteinId = thirdProteinSelect ? parseInt(thirdProteinSelect.value) : null;

    let creatineFlavorInput = document.getElementById('property-creatine-flavor');
    let creatineFlavor = creatineFlavorInput ? creatineFlavorInput.value : '';

    let items = [];
    if (fistProteinId && secondProteinId && thirdProteinId) {
      items = [
        {
          id: fistProteinId,
          quantity: 1,
          properties: {
            "__type": "three_pack"
          },
        },
        {
          id: secondProteinId,
          quantity: 1,
          properties: {
            "__type": "three_pack"
          },
        },
        {
          id: thirdProteinId,
          quantity: 1,
          properties: {
            "__type": "three_pack"
          },
        },
      ];
    } else if (thirdProteinId) {
      if (isSubscription) {
        let selectedOption = thirdProteinSelect.options[thirdProteinSelect.selectedIndex];
        sellingPlanValue = parseInt(selectedOption.getAttribute('data-selling-plan-id')) || 0;
      }
      items = [
        {
          id: thirdProteinId,
          quantity: 1,
          properties: {
            "Creatine Flavor": creatineFlavor
          },
        },
      ];
    } else {
      // Handle error
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      submitButton.parentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
      return;
    }

    // Add selling_plan if available
    if (sellingPlanValue) {
      items.forEach(item => {
        item.selling_plan = sellingPlanValue;
      });
    }

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    };

    fetch('/cart/add.js', config)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          // Handle error
          return;
        }

        if (window.updateConvertAttributes) window.updateConvertAttributes();
        if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
          setTimeout(function(){
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            submitButton.parentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
          },3000);
          drawerOpen();
        }else{
          window.location.href = '/cart';
        }
      })
      .catch((e) => {
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.parentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

function packwiseFreeGift(itemArr, variantId, productId, properties = {}) {
  if(jQuery('.protein_frequency').find('[name="recharge_custom"]').length>0){

    var getSubscription = HPN_getOfferPurchaseType();

    var kitActive = jQuery('.protein_offer .protein_kit_options').find('.protein_kit_btn.active').find('[name="kit"]:checked').val();
    var bundlePack = 'one';
    if(kitActive==2){
      bundlePack = 'two';
    }else if(kitActive==3){
      bundlePack='three';
    }
    if(getSubscription == 'subscribe'){
      kitActive = parseInt(kitActive);
      if(kitActive){
        var bootyFree = jQuery('.protein_frequency_box').find('.bootyprogram_gift_free').attr('data-vid');
        // itemArr.push({
        //   id: bootyFree,
        //   quantity: 1,
        //   properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
        // });
        if(kitActive==2){
          // var shakerFree = jQuery('.protein_frequency_box').find('.shaker_gift_free').attr('data-vid');

          // itemArr.push({
          //   id: shakerFree,
          //   quantity: 1,
          //   properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
          // });
          // if(kitActive==3){
          //   strkit = 'bundle';
          //   var magnesiumFree = jQuery('.protein_frequency_box').find('.magnesium_gift_free').attr('data-vid');
          //   itemArr.push({
          //     id: magnesiumFree,
          //     quantity: 1,
          //     properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
          //   });
          // }
          //console.log("length",jQuery('.protein_offer .protein_flavors.'+strkit+'_flavors .select__select').length);
        }
        if(kitActive==3){
          strkit = 'bundle';
          //var magnesiumFree = jQuery('.protein_frequency_box').find('.magnesium_gift_free').attr('data-vid');
          //itemArr.push({
          //  id: magnesiumFree,
          //  quantity: 1,
          //  properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
          //});
        }
      }
    }
    var strkit='';
    if(kitActive==2){
      strkit='double';
    }else if(kitActive==3){
      strkit = 'bundle';
    }
    if(strkit!=""){
      if(jQuery('.protein_offer .protein_flavors.'+strkit+'_flavors .select__select').length > 0) {
        jQuery('.protein_offer .protein_flavors.'+strkit+'_flavors .select__select').each(function() {
          if(jQuery(this).attr('id')=='Option-5'){
            var strvariant='';
            jQuery('.select.no-limit-select').find('.product-option').each(function(){
              var selectedVariant = jQuery(this).find('option:selected').val();
              if(selectedVariant!="" && selectedVariant!=undefined){
                if(strvariant!=""){
                  strvariant+='-';
                }
                strvariant+=convertToHandle(selectedVariant);
              }
            });
            //console.log("strvariant",strvariant);
            if(strvariant!=""){
              var selectedVal = jQuery(this).find('[data-title="'+strvariant+'"]').val();
              var sellingPlanId = jQuery(this).find('[data-title="'+strvariant+'"]').attr('data-selling-plan-id');
            }
          }else{
            var selectedVal = jQuery(this).find('option:selected').val();
            var sellingPlanId = jQuery(this).find('option:selected').attr('data-selling-plan-id');
          }
          //console.log("selectedVal",selectedVal);
          //console.log("sellingPlanId",sellingPlanId);
          if (selectedVal) {
            if(getSubscription == 'subscribe'){
              if(sellingPlanId==undefined){
                sellingPlanId=0;
              }
              itemArr.push({
                id: selectedVal,
                quantity: 1,
                selling_plan: sellingPlanId,
                properties: {
                  '__bundle_type': bundlePack,
                  ...properties
                }
              });
            }else{
              itemArr.push({
                id: selectedVal,
                quantity: 1,
                properties: {
                  '__bundle_type': bundlePack,
                  ...properties
                }
              });
            }
          }
        });
      }
    }
    console.log("itemArr",itemArr);
    return itemArr;
  }
}

function convertToHandle(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // remove special chars
    .replace(/\s+/g, '-')         // replace spaces with hyphens
    .replace(/-+/g, '-');         // collapse multiple hyphens
}


function bundlePackSubscriptionText(){
  var rechargeType='';
  var bundleType = 'single';
  var nobundlePrice = 0;
  if(jQuery('.protein_offer').find('[name="kit"]').length>0){
    var typesBundle = jQuery('.protein_offer').find('[name="kit"]:checked').val();
    if(typesBundle==2){
      bundleType='double';
    }else if(typesBundle==3){
      bundleType='bundle';
      nobundlePrice = jQuery('.protein__variants').find('#Option-5').find('option').attr('data-price');
    }
  }

  if(jQuery('.protein_frequency').find('[name="recharge_custom"]').length>0){
    rechargeType = jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').val();
  }
  jQuery('.price-text-offer').find('.common-price').hide();
  //console.log("typesBundle",typesBundle,rechargeType,nobundlePrice);
  if(rechargeType=='subscribe'){
    jQuery('.protein_offer').find('.pf_subscribe_content').show();
    jQuery('.price-text-offer').find('.common-price.'+bundleType+'_price').show();
  }else{
    jQuery('.protein_offer').find('.pf_subscribe_content').hide();
    jQuery('.protein_offer').find('.pf_onetime_content').show();
    jQuery('.protein_offer').find('.pf_onetime_content').find('.pf_onetime_free').hide();
    //jQuery('.protein_offer').find('.pf_onetime_content').find('.pf_onetime_free.'+bundleType+'__free').show();
    if(jQuery('.protein_frequency').hasClass('frequency-version-two')){
      console.log("bundleType",bundleType,jQuery('.protein_offer').find('.pf_onetime_content').find('.pf_onetime_free.'+bundleType+'__free_vtwo').length);
      jQuery('.protein_offer').find('.pf_onetime_content').find('.pf_onetime_free.'+bundleType+'__free_vtwo').show();
    }else if(jQuery('.protein_frequency').hasClass('frequency-version-one')){
      jQuery('.protein_offer').find('.pf_onetime_content').find('.pf_onetime_free.'+bundleType+'__free_vone').show();
    }
  }
  if(nobundlePrice!=0 && jQuery('.protein_frequency_header').find('.pf_subscription_saleprice').length>0){
    setTimeout(function(){
      var getPrecentText = jQuery('.protein_frequency_header').find('.pf_subscribe_title.pf_subtitle_vone').text();
      getPrecentText = parseInt(getPrecentText.replace(/\D/g, ''));
      var discountPrice = ((nobundlePrice*getPrecentText)/100);
      var subscribeAmount = (nobundlePrice-discountPrice);

      // EJHPN
      // Force bundle subscribe price to $99.00
      if (bundleType === 'bundle') {
        subscribeAmount = 9900; // cents
      }

      jQuery('.pf_header_subscription').find('.pf_subscription_saleprice').text(Shopify.formatMoney(subscribeAmount));
      if(nobundlePrice!=0){
        jQuery('.pf_header_onetime').find('.pf_subscription_saleprice').text(Shopify.formatMoney(nobundlePrice));
      }
    },200);
  }
}

$(document).ready(function () {
  $(".single_option").addClass("active");
  var setIdint = setInterval(function(){
    if(jQuery('.protein_offer').find('.protein_kit_btn').length>0){
      if($("#subscribe").is(":checked")) {
        priceupdateAllFirst();
        clearInterval(setIdint);
      }
    }
  },500);

  $(".protein_kit_btn").on("click", function (e) {
    e.preventDefault();
    console.log("[OFFER] ===== KIT BUTTON CLICKED =====");

    const typeskit = $(this).find('input[name="kit"]').val();
    console.log("[OFFER] Kit type clicked:", typeskit);
    console.log("[OFFER] Kit button element:", $(this));
    console.log("[OFFER] Kit button classes:", $(this).attr('class'));

    $(".protein_kit_btn").removeClass("active");
    $(this).addClass("active");
    $('input[name="kit"]').prop('checked', false);
    $(this).find('input[name="kit"]').prop('checked', true);

    console.log("[OFFER] Kit updated - typeskit:", typeskit);
    console.log("[OFFER] Active kit button now:", jQuery('.protein_kit_btn.active').find('input[name="kit"]').val());

    bundlePackSubscriptionText();
    toggleContent();

    setTimeout(() => {
      showHideFreeProduct(typeskit);
    }, 200);

    jQuery('.product_buybutton_block').find('.product-form__submit').attr('type', 'button');

    if(jQuery('.creatine_protein_offer').find('.bundle_option.active').length>0){
      if(jQuery('.creatine_protein_offer').find('.protein_frequency').find('.protein_frequency_label.first').length>0){
        jQuery('.creatine_protein_offer').find('.protein_frequency').find('.protein_frequency_label.first').hide();
        jQuery('.creatine_protein_offer').find('.protein_frequency').find('.protein_frequency_label.second').show();
      }
    }else if(jQuery('.creatine_protein_offer').find('.protein_frequency').find('.protein_frequency_label.first').length>0){
        jQuery('.creatine_protein_offer').find('.protein_frequency').find('.protein_frequency_label.first').show();
        jQuery('.creatine_protein_offer').find('.protein_frequency').find('.protein_frequency_label.second').hide();
      }
  });

  function showHideFreeProduct(typeskit){
    typeskit = parseInt(typeskit);
    jQuery('.protein_frequency').find('.gift_product_box').hide();
    var rechargeType='';
    if(jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').length>0){
      rechargeType = jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').val();
    }
    var bundleType='single';
    jQuery('.protein_frequency').find('.gift_product_box .gp_free_label.bundle_free_label').hide();
    jQuery('.protein_frequency').find('.common-dlr-text').hide();
    var isCreatine = jQuery('[data-creatine="true"]').length > 0;
    jQuery('.protein_frequency').find('.gift_product_box.beauty_bottle_free').hide();
    jQuery('.protein_frequency').find('.gift_product_box.beauty_bottle_free-v').hide();
    if(typeskit==1){
      jQuery('.protein_frequency').find('.gift_product_box .gp_free_label:not(.bundle_free_label)').show();
      jQuery('.protein_frequency').find('.gift_product_box.bootyprogram_gift_free').show();
      jQuery('.protein_frequency').find('.gift_product_box.bootyprogram_gift_free-v').show();
      jQuery('.protein_frequency').find('.gift_product_box.shaker_gift_free').show();
      jQuery('.protein_frequency').find('.gift_product_box.shaker_gift_free-v').show();
      if(isCreatine){
        jQuery('.protein_frequency').find('.gift_product_box.beauty_bottle_free').show();
        jQuery('.protein_frequency').find('.gift_product_box.beauty_bottle_free-v').show();
      }
      jQuery('.protein_frequency').find('.dltext.common-dlr-text').show();
    }
    else if(typeskit==2){
      jQuery('.protein_frequency').find('.gift_product_box .gp_free_label:not(.bundle_free_label)').show();
      jQuery('.protein_frequency').find('.gift_product_box.bootyprogram_gift_free').show();
      jQuery('.protein_frequency').find('.gift_product_box.shipping_gift_free').show();
      jQuery('.protein_frequency').find('.gift_product_box.shaker_gift_free').show();
      jQuery('.protein_frequency').find('.gift_product_box.bootyprogram_gift_free-v').show();
      jQuery('.protein_frequency').find('.gift_product_box.shipping_gift_free-v').show();
      jQuery('.protein_frequency').find('.gift_product_box.shaker_gift_free-v').show();
      if(isCreatine){
        jQuery('.protein_frequency').find('.gift_product_box.beauty_bottle_free').show();
        jQuery('.protein_frequency').find('.gift_product_box.beauty_bottle_free-v').show();
      }
      jQuery('.protein_frequency').find('.free-dltext.common-dlr-text').show();
      bundleType='double';
    }
    else if(typeskit==3){
      jQuery('.protein_frequency').find('.gift_product_box').show();
      bundleType='bundle';
      jQuery('.protein_frequency').find('.gift_product_box .gp_free_label.bundle_free_label').show();
      jQuery('.protein_frequency').find('.free-dltext.common-dlr-text').show();
    }
  }

  function priceupdateAllFirst(){
    if(jQuery('.protein_offer').find('.protein_kit_btn').length>0){
      if($("#subscribe").is(":checked")) {
        jQuery('.protein_offer').find('.protein_kit_btn').each(function(){
          jQuery(this).find('.pk_option_pricebox').find('.ten_off_price').show();
          jQuery(this).find('.pk_option_pricebox').find('.pk_sale_price').hide();
        });
      }else{
        jQuery('.protein_offer').find('.protein_kit_btn').each(function(){
          jQuery(this).find('.pk_option_pricebox').find('.ten_off_price').hide();
          jQuery(this).find('.pk_option_pricebox').find('.pk_sale_price').show();
        });
      }
    }
  }

  function toggleContent() {
    console.log("[OFFER] === toggleContent CALLED ===");
    console.log("[OFFER] Single checked?", $("#single_portein").is(":checked"));
    console.log("[OFFER] Double checked?", $("#double_portein").is(":checked"));
    console.log("[OFFER] Bundle checked?", $("#bundle_portein").is(":checked"));

    //console.log("chhhhh",$("#double_portein").is(":checked"));
    $(".single_flavors, .double_flavors, .bundle_flavors").hide(); // Hide all first
    if(jQuery('.product--details').find('.protein_offer').length>0){
      if(jQuery('.product--details').find('.protein_offer').is(':visible')){
        $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').attr('type','button');
      }
    }
    $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').hide();
    if ($("#single_portein").is(":checked")) {
      console.log("[OFFER] Single pack selected");
      var offprice = $("#single_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.ten_off_price').text();
      var sprice = $("#single_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_sale_price').text();
      $(".single_flavors").show();

      var productHandle = getUrlBaseSegement();
      var percentOffText = '10%';
      if(productHandle=='hydration'){
        percentOffText = '20%';
      }
      $('.pf_onetime_details h6').html('Switch to a subscription & <span class="off-percentage-text">SAVE '+percentOffText+'</span>');
      $('.pf_subtitle_vone').html('Subscribe & Save '+percentOffText);
      $('.pf_subtitle_vtwo').html('Subscribe <b>Save '+percentOffText+'</b>');

      /*setTimeout(function(){
        if(jQuery('.single_option.protein_kit_btn.active').length>0){
          offprice = jQuery('.single_option.protein_kit_btn.active').find('.pk_option_pricebox').find('.ten_off_price').text();
          $('.pf_header_onetime').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offprice);
          $('.pf_header_onetime').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(sprice);
        }else{
          $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(offprice);
          $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(sprice);
        }
      },1000);*/
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').addClass('protein_offer_first');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_second');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_third');
    }
    else if ($("#double_portein").is(":checked")) {
      console.log("[OFFER] Two-pack selected");
      var cprice = $("#double_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_compare_price').text();
      var sprice = $("#double_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_sale_price').text();
      var offprice = $("#double_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.ten_off_price').text();

      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(sprice);
      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offprice);

      $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(sprice);

      var productHandle = getUrlBaseSegement();
      var percentOffText = '20%';
      if(productHandle=='hydration'){
        percentOffText = '25%';
      }
      $('.pf_subtitle_vone').html('Subscribe & Save '+percentOffText);
      $('.pf_subtitle_vtwo').html('Subscribe <b>Save '+percentOffText+'</b>');
      $('.subscription-radio .rc-radio__subscription').text('Subscribe & Save '+percentOffText);
      $('.subscription-radio .rc-radio__price').text(offprice);
      $('.onetime-radio .rc-radio__price').text(sprice);
      $('.pf_onetime_details h6').html('Switch to a subscription & <span class="off-percentage-text">SAVE '+percentOffText+'</span>');

      $(".double_flavors").show();
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_first');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').addClass('protein_offer_second');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_third');
    }
    else if ($("#bundle_portein").is(":checked")) {
      console.log("[OFFER] Bundle pack selected");
      var cprice = $("#bundle_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_compare_price').text();
      var sprice = $("#bundle_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_sale_price').text();
      var offprice = $("#bundle_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.ten_off_price').text();
      console.log("[OFFER] Bundle prices - compare:", cprice, "sale:", sprice, "off:", offprice);

      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(sprice);
      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offprice);

      $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').show();
      $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(cprice);
      $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(sprice);

      var productHandle = getUrlBaseSegement();
      var percentOffText = '25%';
      if(productHandle=='one-sol-creatine-leucine' || productHandle=='hydration'){
        percentOffText = '20%';
      }
      $('.pf_subtitle_vone').html('Subscribe & Save '+percentOffText);
      $('.pf_subtitle_vtwo').html('Subscribe <b>Save '+percentOffText+'</b>');
      $('.subscription-radio .rc-radio__subscription').text('Subscribe & Save '+percentOffText);
      $('.subscription-radio .rc-radio__price').text(offprice);
      $('.onetime-radio .rc-radio__price').text(sprice);
      $('.pf_onetime_details h6').html('Switch to a subscription & <span class="off-percentage-text">SAVE '+percentOffText+'</span>');

      $(".bundle_flavors").show();
      console.log("[OFFER] Bundle flavors shown");
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_first');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_second');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').addClass('protein_offer_third');
    }
    console.log("[OFFER] === toggleContent COMPLETED ===");
    variantWisePriceSet();
  }

  toggleContent();
  $("input[name='kit']").on("change", toggleContent);

  function toggleContentSubscribe() {
    console.log("[OFFER] === toggleContentSubscribe CALLED ===");
    if ($("#subscribe").is(":checked")) {
      console.log("[OFFER] Subscribe is checked");
      $(".pf_subscribe_content").show();
      $(".pf_onetime_content").hide();
      $(".rc-widget").find('.rc-template__radio').find('.subscription-radio').find('[name="purchaseOption"]').trigger('click');
    }
    else {
      console.log("[OFFER] Onetime is checked");
      $(".pf_subscribe_content").hide();
      $(".pf_onetime_content").show();
      $(".rc-widget").find('.rc-template__radio').find('.onetime-radio').find('[name="purchaseOption"]').trigger('click');
    }
    console.log("[OFFER] === toggleContentSubscribe COMPLETED ===");
    bundlePackSubscriptionText();
  }
  toggleContentSubscribe();

  $("input[name='recharge_custom']").on("change", function(){
    console.log("[OFFER] ===== SUBSCRIPTION/ONETIME CHANGED =====");
    console.log("[OFFER] New value:", $(this).val());
    console.log("[OFFER] Checked element:", $(this));
    console.log("[OFFER] All recharge_custom inputs:", jQuery('input[name="recharge_custom"]'));

    var currentValue = jQuery('input[name="recharge_custom"]:checked').val();
    console.log("[OFFER] Current checked value:", currentValue);
    console.log("[OFFER] Is subscribe?", currentValue === 'subscribe');
    console.log("[OFFER] Is onetime?", currentValue === 'onetime');

    toggleContentSubscribe();
    variantWisePriceSet();
    priceupdateAllFirst();

    console.log("[OFFER] Subscription change handlers executed");
  });

  $(".product-form__input_v1 label").on("click", function () {
    var vid = $(this).attr('data-vid');
    $(".product-form__input_v1 label").removeClass('active');
    $(this).addClass('active');
    $('.product_buybutton_block').find('.product-form').find('.form').find('[name="id"]').val(vid);
  });
});

function variantWisePriceSet(){
  var rechargeType = '';
  if (jQuery('.protein_frequency').find('[name="recharge_custom"]').length > 0) {
    rechargeType = jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').val();
  }
  const isBundleChecked = $("#bundle_portein").is(":checked");
  if (rechargeType === 'subscribe') {
    let offprice = '';

    if (isBundleChecked) {
      offprice = jQuery('.pf_header_subscription .pf_subscription_pricebox .pf_subscription_saleprice').text().trim();
    } else {
      offprice = jQuery('.pf_header_subscription .pf_subscription_saleprice').text().trim();
    }
    if (offprice) {
      updateAllPriceBlocks(offprice);
    }

  } else {
    let sprice = '';

    if (isBundleChecked) {
      sprice = jQuery('.pf_header_onetime .pf_subscription_pricebox .pf_subscription_saleprice').text().trim();
    } else {
      sprice = jQuery('.pf_header_onetime .pf_subscription_saleprice').text().trim();
    }
    if (sprice) {
      updateAllPriceBlocks(sprice);
    }
  }
  //start img set when this product for bundle variant Woman Of The Year Bundle
  var getImgSubscibe = '';
  if(jQuery('.protein_kit_options').find('.bundle_option.protein_kit_btn').find('.pk_col_banner img[data-subscribe-img]').length>0){
    //console.log("under",rechargeType);
    if(rechargeType == 'subscribe'){
      getImgSubscibe = jQuery('.protein_kit_options').find('.bundle_option.protein_kit_btn').find('.pk_col_banner img').attr('data-subscribe-img');
    }else{
      getImgSubscibe = jQuery('.protein_kit_options').find('.bundle_option.protein_kit_btn').find('.pk_col_banner img').attr('data-onetime-img');
    }
    //console.log("getImgSubscibe",getImgSubscibe);
    if(getImgSubscibe!=undefined && getImgSubscibe!=""){
      jQuery('.protein_kit_options').find('.bundle_option.protein_kit_btn').find('.pk_col_banner img').attr('src',getImgSubscibe);
    }
  }
  //end img set when this product for bundle variant Woman Of The Year Bundle
}

function updateAllPriceBlocks(price) {
  setTimeout(function(){
    if(jQuery('.price__block .price-item--regular').length>0){
      jQuery('.price__block .price-item--regular strong').text(price);
    }
    if(jQuery('.product--details .price-item--regular').length>0){
      jQuery('.product--details .price-item--regular strong').text(price);
    }
    var rechargeType = '';
    if(jQuery('.protein_frequency').find('[name="recharge_custom"]').length > 0) {
      rechargeType = jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').val();
    }
    if(jQuery('.protein_kit_options').find('.protein_kit_btn').length>0){
      jQuery('.protein_kit_options .protein_kit_btn').each(function(){
        console.log("check class",jQuery(this).parent('div').find('.protein_kit_btn.active').find('.pk_option_pricebox').hasClass('bundle_protein_price'));
        if(rechargeType=='subscribe' && jQuery(this).parent('div').find('.protein_kit_btn.active').find('.pk_option_pricebox').hasClass('bundle_protein_price')){
          // if(jQuery(this).find('.pk_option_pricebox').find('.ten_off_price').length>0){
          //   jQuery(this).find('.pk_option_pricebox').find('.ten_off_price').show();
          //   jQuery(this).find('.pk_option_pricebox').find('.pk_sale_price').hide();
          // }

          // var saleprice = jQuery('.pf_header_subscription .pf_subscription_pricebox .pf_subscription_saleprice').text().trim();
          // if(jQuery(this).find('.pk_option_pricebox').find('.pk_sale_price').length>0){
          //   var originalPrice = jQuery(this).find('.pk_option_pricebox').find('.pk_sale_price').text();
          //   if(originalPrice!="" && originalPrice!=undefined){
          //     originalPrice = originalPrice.replace(/[^0-9.]/g, '');
          //     var discountPercent = 25;
          //     console.log("originalPrice",originalPrice);
          //     var discountAmount = (discountPercent / 100) * originalPrice;
          //     saleprice = originalPrice - discountAmount;
          //     if(saleprice!=undefined && saleprice>0){
          //       saleprice = (saleprice*100);
          //       saleprice = Shopify.formatMoney(saleprice);
          //     }
          //   }
          //   jQuery(this).parent('div').find('.protein_kit_btn.active').find('.pk_option_pricebox').find('.ten_off_price').text(saleprice);
          //   if(rechargeType=='subscribe'){
          //     jQuery('.price__block').find('.price-item.price-item--regular strong').text(saleprice);
          //   }else{
          //     jQuery('.price__block').find('.price-item.price-item--regular strong').text(originalPrice);
          //   }
          // }

          // EJHPN
          var saleprice = jQuery('.pf_header_subscription .pf_subscription_pricebox .pf_subscription_saleprice')
            .text()
            .trim();

          // Show discounted price on the active bundle tile; hide regular
          if (jQuery(this).find('.pk_option_pricebox').find('.ten_off_price').length > 0) {
            jQuery(this).find('.pk_option_pricebox').find('.ten_off_price').show();
            jQuery(this).find('.pk_option_pricebox').find('.pk_sale_price').hide();
          }

          // Mirror the header price into the active tile and main PDP price
          jQuery(this)
            .parent('div')
            .find('.protein_kit_btn.active .pk_option_pricebox .ten_off_price')
            .text(saleprice);

          jQuery('.price__block .price-item.price-item--regular strong').text(saleprice);


        }else{
          var objhtml = jQuery(this);
          if(objhtml.parent('div').find('.protein_kit_btn.active').find('.pk_option_pricebox').find('.pk_sale_price').length>0){
            var salePriceget = objhtml.parent('div').find('.protein_kit_btn.active .pk_option_pricebox').find('.pk_sale_price').text();
            var offPriceGet = objhtml.parent('div').find('.protein_kit_btn.active .pk_option_pricebox').find('.ten_off_price').text();
            $('.pf_header_onetime').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(salePriceget);
            $('.pf_header_subscription').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(salePriceget);
            $('.pf_header_subscription').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offPriceGet);
            if(rechargeType=='subscribe'){
              objhtml.parent('div').find('.protein_kit_btn.active .pk_option_pricebox').find('.ten_off_price').show();
              objhtml.parent('div').find('.protein_kit_btn.active .pk_option_pricebox').find('.pk_sale_price').hide();
              jQuery('.price__block').find('.price-item.price-item--regular strong').text(offPriceGet);
            }else{
              objhtml.parent('div').find('.protein_kit_btn.active .pk_option_pricebox').find('.ten_off_price').hide();
              objhtml.parent('div').find('.protein_kit_btn.active .pk_option_pricebox').find('.pk_sale_price').show();
              jQuery('.price__block').find('.price-item.price-item--regular strong').text(salePriceget);
            }
          }
        }
      });
    }
  },500);
}


function addItemCart(Quantity,variantId,sellingId=''){
  if(variantId!=undefined && variantId!=""){
     $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
          quantity: Quantity,
          id: variantId,
          selling_plan:sellingId
      },
      success: function(cart) {
        if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
         drawerOpen();
        } else{
          window.location.href = '/cart';
        }
      },
      error: function(response) {
          //alert('Something went wrong!!');
      }
    });
  }
}
// Double Flavor image change for option 1 and option 2
$(document).on('change','.protein_flavors.double_flavors #Option-1',function () {
  const $selected = $(this).find('option:selected');
  const imgUrl = $selected.data('img');
  //console.log("imgUrl",imgUrl);
  if (imgUrl) {
    $('.protibne_first_banner').attr('src', imgUrl);
    //console.log('Image URL:', imgUrl);
  }
});

$(document).on('change','.protein_flavors.double_flavors #Option-2', function () {
  const $selected = $(this).find('option:selected');
  const imgUrl = $selected.data('img');
  if (imgUrl) {
    $('.protibne_second_banner').attr('src', imgUrl);      // e.g. preview the image
    //console.log('Image URL:', imgUrl);      // debug
  }
});

// No Limit Bundle Flavor image change for option 1 and option 2 and 3
$(document).on('change','.protein_flavors.bundle_flavors .bundle-flover-no-limit .product-option',function () {
  console.log('[OFFERS] bundle select changed');
  const $selected = $(this).find('option:selected');
  const indeximg = $(this).attr('data-index');
  const imgUrl = $selected.data('img');
  if (imgUrl && $('.protein_flavor_banner.flavor_img_'+indeximg).length>0) {
    $('.protein_flavor_banner.flavor_img_'+indeximg).find('img').attr('src', imgUrl);
    console.log('[OFFERS] Image URL:', imgUrl);
  }

  // Update Option-5 based on selected options
  var strvariant = '';
  jQuery('.select.no-limit-select').find('.product-option').each(function(){
    if ($(this).hasClass('creatine-option')) return; // Skip creatine for strvariant
    var selectedVariant = $(this).find('option:selected').val();
    console.log('[OFFERS] selected variant:', selectedVariant);
    if(selectedVariant!="" && selectedVariant!=undefined){
      if(strvariant!=""){
        strvariant+='-';
      }
      strvariant += convertToHandle(selectedVariant);
    }
  });
  console.log('[OFFERS] strvariant after flavors:', strvariant);
  if(strvariant!=""){
    var $option5 = jQuery('#Option-5');
    // Find the option in Option-5 where data-title matches strvariant
    var matchingOption = $option5.find('option').filter(function() {
      return $(this).data('title') === strvariant;
    });
    if(matchingOption.length > 0){
      var variantId = matchingOption.val();
      $option5.val(variantId);
      console.log('[OFFERS] Option-5 set to variant ID:', variantId, 'for strvariant:', strvariant);
    } else {
      console.log('[OFFERS] No matching option found in Option-5 for strvariant:', strvariant);
    }
  }
});


$(document).on('click','.protein_offer_two_one .single_flavors .variant__select',function () {
  var dataImg = $(this).attr('data-img');
  $('.protein_offer_two_one').find('.single_option').find('.pk_inner_content.protein_kit_col').find('.pk_col_banner').find('img').attr('src', dataImg);
});

/***************** BUNDLE PACK OFFER NEW -- END *******************/

var interID;
$(document).ready(function() {
  if(jQuery('body').hasClass('page-product')){
    interID = setInterval(function() {
      if(jQuery('.protein_offer').length>0){
        $('html, body').animate({ scrollTop: 0 }, 10);
        window.scrollTo(0, 0);
        setTimeout(function(){
          clearInterval(interID);
        },1000);
      }
    }, 1000);
  }
});

$(window).on('load', function() {
  if(interID){
    setTimeout(function(){
      clearInterval(interID);
    },200);
  }
});

/****************************************************
 * 3 Column Layout Start
****************************************************/

jQuery(window).on('load resize', function () {
  if (jQuery(window).width() >= 1201) {
    var thirdLayoutLoad = setInterval(function(){
      if(jQuery('body').hasClass('three_column_lauout_load')){
        if($('.shopify-app-block.recharge-subscription-widget').length>0){
          if($('.shopify-app-block.recharge-subscription-widget').find('[data-v-app]').find('.rc-widget').length > 0){
            var rechargeHtml = $('.shopify-app-block.recharge-subscription-widget').prop('outerHTML');

            if($('.extra__recharge_data_load').length>0){
              $('.extra__recharge_data_load').html(rechargeHtml);
            }
            if($('.product--details.product__info-wrapper').find('.shopify-app-block.recharge-subscription-widget').find('div[data-v-app]').length>0){
              $('.product--details.product__info-wrapper').find('.shopify-app-block.recharge-subscription-widget').find('div[data-v-app]').hide();
            }
            clearInterval(thirdLayoutLoad);
          }
        }

        if(thirdLayoutLoad!=undefined){
          setTimeout(function(){
            clearInterval(thirdLayoutLoad);
          },10000);
        }

        /*-------------------------------------------------- Variant Block Start -------------------------------------------------*/

          if(jQuery('.product--details.product__info-wrapper').find('.product_variant_block').length>0){
            var variatnblock = jQuery('.product--details.product__info-wrapper').find('.product_variant_block').prop('outerHTML');
            if(variatnblock!="" && jQuery('.product--detail-third--part').find('.extra_variant_data_load').find('.product_variant_block').length==0){
              jQuery('.product--detail-third--part').find('.extra_variant_data_load').html(variatnblock);
              jQuery('.product--details.product__info-wrapper').find('.product_variant_block').html('');
            }
          }

        /*-------------------------------------------------- Variant Block End ---------------------------------------------------*/

        /*------------------------------------------------- Delivery Date Block Start ------------------------------------------------*/

          if(jQuery('.product--details.product__info-wrapper').find('.deliveryblock').length>0){
            var deliveryblock = jQuery('.product--details.product__info-wrapper').find('.deliveryblock').prop('outerHTML');
            if(deliveryblock!="" && jQuery('.product--detail-third--part').find('.deliveryblock-extra-addtocart').find('.deliveryblock').length==0){
              deliveryblock = deliveryblock.replace(/timer-display/g, 'timer-display-convert');
              jQuery('.product--detail-third--part').find('.deliveryblock-extra-addtocart').append(deliveryblock);
              jQuery('.product--details.product__info-wrapper').find('.deliveryblock').hide();
            }
          }

        /*------------------------------------------------- Delivery Date Block End --------------------------------------------------*/

        /*------------------------------------------------- Custom Button Add To Cart Button Start ------------------------------------------------*/

          if(jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block').length>0){
            jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block').prop('outerHTML');
            jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block').hide();
          }

        /*------------------------------------------------- Custom Button Add To Cart Button End ------------------------------------------------*/

        /*------------------------------------------------- Shipping Description Block Start --------------------------------------------------*/

          if(jQuery('.product--details.product__info-wrapper').find('.shippingversion').length>0){
            var shippingversion = jQuery('.product--details.product__info-wrapper').find('.shippingversion').prop('outerHTML');
            if(jQuery('.product--detail-third--part').find('.shippingversion-extra-ship').find('.shippingversion').length == 0){
              jQuery('.product--detail-third--part').find('.shippingversion-extra-ship').html(shippingversion);
              jQuery('.product--details.product__info-wrapper').find('.shippingversion').hide();
            }
          }

        /*------------------------------------------------- Shipping Description Block End --------------------------------------------------*/

        /*------------------------------------------------- Quantity Picker Block Start --------------------------------------------------*/

          var inputQuantity = setInterval(function(){
            if(jQuery('.product--details.product__info-wrapper').find('.product-form__quantity').length>0){
              var frmQtyblock = jQuery('.product--details.product__info-wrapper').find('.product-form__input.product-form__quantity').prop('outerHTML');
              if(frmQtyblock!="" && jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__quantity').length==0){
                jQuery('.product--detail-third--part').find('.extra_frm_qty_load').html(frmQtyblock);
                jQuery('.product--details.product__info-wrapper').find('.product-form__input.product-form__quantity').hide();
                jQuery('.product--details.product__info-wrapper').find('.product-form__input.product-form__quantity').html('');

                /*jQuery(document).on('click','.extra_frm_qty_load .product-form__quantity [name="plus"]',function(){
                  var qty = jQuery(this).siblings('.quantity__input').val();
                  jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block form').find('[name="quantity"]').val(qty);
                  jQuery('.product--details.product__info-wrapper').find('.product-form__quantity').find('[name="plus"]').trigger("click");
                });

                jQuery(document).on('click','.extra_frm_qty_load .product-form__quantity [name="minus"]',function(){
                  var qty = jQuery(this).siblings('.quantity__input').val();
                  jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block form').find('[name="quantity"]').val(qty);
                  jQuery('.product--details.product__info-wrapper').find('.product-form__quantity').find('[name="minus"]').trigger("click");
                });
                var inputHidden = '<input type="hidden" name="quantity" value="1">';
                if(jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block form').find('[name="quantity"]').length==0){
                  jQuery('.product--details.product__info-wrapper').find('.product_buybutton_block form').append(inputHidden);
                }*/
                if(jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__input.product-form__quantity').attr('style')!== undefined){
                  jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__input.product-form__quantity').hide();
                }
                clearInterval(inputQuantity);
              }
            }
          },500);

          if(inputQuantity!=undefined){
            setTimeout(function(){
              clearInterval(inputQuantity);
            },10000);
          }

        /*------------------------------------------------- Quantity Picker Block End --------------------------------------------------*/

        /*------------------------------------------------- ATC Button Below Payment Icon Block Start --------------------------------------------------*/

          if(jQuery('.product--details.product__info-wrapper').find('.custom_liquid_block').length>0){
            var paymentIconBlock = jQuery('.product--details.product__info-wrapper').find('.custom_liquid_block').prop('outerHTML');
            if(paymentIconBlock!=""  && jQuery('.product--detail-third--part').find('.extra_payment_logo').length>0){
              if(jQuery('.product--detail-third--part').find('.extra_payment_logo').find('.custom_liquid_block').length==0){
                jQuery('.product--detail-third--part').find('.extra_payment_logo').html(paymentIconBlock);
                jQuery('.product--details.product__info-wrapper').find('.custom_liquid_block').hide();
              }
            }
          }

        /*------------------------------------------------- ATC Button Below Payment Icon Block End --------------------------------------------------*/

        /*------------------------------------------------- One Time Text and Price Change Start --------------------------------------------------*/

          var thirdOneTimePrice = setInterval(function(){
            if(jQuery('.recharge-subscription-widget').find('label.rc-radio.onetime-radio .rc-radio__label').length>0){
              var getHtmlContent = jQuery('.recharge-subscription-widget').find('label.rc-radio.onetime-radio .rc-radio__label').html();
              if(getHtmlContent != "" && jQuery('.extra__recharge_data_load').find('label.rc-radio.onetime-radio .rc-radio__label').length>0){
                jQuery('.extra__recharge_data_load').find('label.rc-radio.onetime-radio .rc-radio__label').html(getHtmlContent);
              }
              clearInterval(thirdOneTimePrice);
            }
          }, 200);

        /*------------------------------------------------- One Time Text and Price Change End --------------------------------------------------*/

        /*------------------------------------------------- Save Off Text Subscribe Label Start --------------------------------------------------*/

          var thirdLayoutSaveText = setInterval(function(){
            if(jQuery('.recharge-subscription-widget').find('.custom-save10-row').length>0){
              var getHtmlContent = jQuery('.recharge-subscription-widget').find('.custom-save10-row').prop('outerHTML');
              $('.extra__recharge_data_load').find('label.rc-radio.subscription-radio').append(getHtmlContent);
              clearInterval(thirdLayoutSaveText);
            }
          }, 200);

        /*------------------------------------------------- Save Off Text Subscribe Label End ----------------------------------------------------*/

        /*------------------------------------------------- Position Change after Subscription Change Event Start --------------------------------------------------*/

          jQuery('[name="purchaseOption"]').on("change",function(){
            jQuery('.product--detail-third--part.subscription-section-one').find('.rc-radio').removeClass('rc-radio--active');
            if(jQuery(this).val() == 'onetime'){
              jQuery('.rc-radio.onetime-radio').addClass('rc-radio--active');
              if(jQuery('.product--detail-third--part.subscription-section-one').find('.custom-subscribe-bulletlist').length>0){
                //jQuery('.product--detail-third--part.subscription-section-one').find('.custom-subscribe-bulletlist').hide();
                if(jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__input.product-form__quantity').length>0){
                  jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__input.product-form__quantity').show();
                }
              }
            }else{
              if(jQuery('.product--detail-third--part.subscription-section-one').find('.custom-subscribe-bulletlist').length>0){
                jQuery('.product--detail-third--part.subscription-section-one').find('.custom-subscribe-bulletlist').show();
              }else if(jQuery('.recharge-subscription-widget').find('.custom-subscribe-bulletlist').length>0){
                var getHtmlContent = jQuery('.recharge-subscription-widget').find('.custom-subscribe-bulletlist').prop('outerHTML');
                jQuery('.product--detail-third--part.subscription-section-one').find('.subscription-radio').append(getHtmlContent);
              }
              if(jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__input.product-form__quantity').length>0){
                jQuery('.product--detail-third--part').find('.extra_frm_qty_load').find('.product-form__input.product-form__quantity').hide();
              }
              jQuery('.rc-radio.subscription-radio').addClass('rc-radio--active');
            }
          });

        /*------------------------------------------------- Position Change after Subscription Change Event End ----------------------------------------------------*/

        /*------------------------------------------------- Subscribe Type Sub Description Text Add Start --------------------------------------------------*/

          var thirdLayoutLoadText = setInterval(function(){
            if(jQuery('.recharge-subscription-widget').find('.custom-subscribe-bulletlist').length>0){
              var getHtmlContent = jQuery('.recharge-subscription-widget').find('.custom-subscribe-bulletlist').prop('outerHTML');
              if(getHtmlContent!="" && getHtmlContent!=undefined && jQuery('.product--detail-third--part.subscription-section-one').find('.custom-subscribe-bulletlist').length==0){
                jQuery('.product--detail-third--part.subscription-section-one').find('.subscription-radio').append(getHtmlContent);
                clearInterval(thirdLayoutLoadText);
              }
            }
          }, 200);

        /*------------------------------------------------- Subscribe Type Sub Description Text Add End --------------------------------------------------*/

        /*------------------------------------------------- Subscription details anchor tooltip Move Start --------------------------------------------------*/

          var moveDetailsIntervalConvert = setInterval(function () {
            var details = document.querySelector('.rc-subscription-details');
            var subscribeLabel = document.querySelector('label.rc-radio.subscription-radio');
            if (details && subscribeLabel) {
              // insert as the next sibling of the subscribe <label>
              $('label.rc-radio.subscription-radio').after(details)
              //subscribeLabel.parentNode.insertBefore(details, subscribeLabel.nextSibling);
              clearInterval(moveDetailsIntervalConvert);
            }
          }, 200);

        /*------------------------------------------------- Subscription details anchor tooltip Move End --------------------------------------------------*/
      }
    }, 100);
  }
});

/*------------------------------------------------- Three layout convert add to cart button js start  --------------------------------------------------*/

  jQuery(document).on("click",".product-form__buttons.custom-extra-addtocart",function(){
    if(jQuery('.product_buybutton_block').find('.product-form__buttons [name="add"]').length>0){
      jQuery('.product_buybutton_block').find('.product-form__buttons [name="add"]').trigger('click');
    }
  });

/*------------------------------------------------- Three layout convert add to cart button js start  --------------------------------------------------*/

/****************************************************
 * 3 Column Layout End
****************************************************/


$('.ptb-item-wrapper').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    pauseOnHover: false,
    arrows: false,
    dots: false,
    cssEase: 'linear',
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });



// THREE COLUMN LAYOUT -- START
document.addEventListener("DOMContentLoaded", function () {
  var threeColumnLoad = setInterval(function () {
    const mainWrapper = document.querySelector(".main_product_threecolumn");
    if (!mainWrapper) return;

    const mq = window.matchMedia("(max-width: 1120px)");

    const moveElements = document.querySelectorAll(
      ".main_product_threecolumn .product__info-wrapper .deliveryblock, \
       .main_product_threecolumn .product__info-wrapper .product_buybutton_block, \
       .main_product_threecolumn .product__info-wrapper .protein_offer"
    );

    const targetContainer = document.querySelector(
      ".main_product_threecolumn .main_product_wrapper .pdp_last_col .pdp_lcol_content"
    );

    if (!targetContainer || !moveElements.length) return;

    const store = new Map();

    moveElements.forEach(el => {
      store.set(el, {
        parent: el.parentNode,
        next: el.nextSibling
      });
    });

    function moveToDesktop() {
      moveElements.forEach(el => {
        if (!targetContainer.contains(el)) {
          targetContainer.appendChild(el);
        }
      });
    }

    function moveBackToMobile() {
      moveElements.forEach(el => {
        const data = store.get(el);
        if (!data) return;

        if (data.next && data.parent.contains(data.next)) {
          data.parent.insertBefore(el, data.next);
        } else {
          data.parent.appendChild(el);
        }
      });
    }

    function toggle(e) {
      if (e.matches) {
        // ≤1120px
        moveBackToMobile();
      } else {
        // ≥1121px
        moveToDesktop();
      }
    }

    toggle(mq);
    mq.addEventListener("change", toggle);

    clearInterval(threeColumnLoad);
  }, 100);
});

// THREE COLUMN LAYOUT -- END

// THREE COLUMN LAYOUT BUNDLE -- START
document.addEventListener("DOMContentLoaded", function () {
  const subscribeInput = document.querySelector('#subscribe');
  const onetimeInput = document.querySelector('#onetime');

  const subscribeLabel = document.querySelector(
    '.protein_frequency_header .pf_subscription_label[for="subscribe"]'
  );
  const onetimeLabel = document.querySelector(
    '.protein_frequency_header .pf_subscription_label[for="onetime"]'
  );

  const options = document.querySelectorAll(
    '.single_option, .double_option, .bundle_option'
  );

  const giftProducts = document.querySelectorAll('.gift-product');
  const giftWrapper = document.querySelector('.bundle-gift-wrapper');

  const titleOnetime = document.querySelector('.block-title-onetime');
  const titleSubscribe = document.querySelector('.block-title-subscribe');
  const titleSubscribeTwo = document.querySelector('.block-title-subscribe-two');

  let isSubscribeActive = false;

  /* ---------- Helpers ---------- */
  function hideAllTitles() {
    if (titleOnetime) titleOnetime.style.display = 'none';
    if (titleSubscribe) titleSubscribe.style.display = 'none';
    if (titleSubscribeTwo) titleSubscribeTwo.style.display = 'none';
  }

  function resetUnlock() {
    giftProducts.forEach(item => item.classList.remove('unlock'));
  }

  function applyUnlock() {
    if (!isSubscribeActive) return;
    resetUnlock();
    giftProducts.forEach(item => item.classList.add('unlock'));
  }

  function getActiveOption() {
    return document.querySelector(
      '.single_option.active, .double_option.active, .bundle_option.active'
    );
  }

  /* ---------- Message Logic ---------- */
  function showSubscribeMessage(option) {
    hideAllTitles();

    if (option && option.classList.contains('single_option')) {
      if (titleSubscribeTwo) titleSubscribeTwo.style.display = 'block';
    } else {
      if (titleSubscribe) titleSubscribe.style.display = 'block';
    }
  }

  function activateSubscribe(option = null) {
    isSubscribeActive = true;
    hideAllTitles();

    const activeOption = option || getActiveOption();
    showSubscribeMessage(activeOption);
    applyUnlock();
  }

  function activateOnetime() {
    isSubscribeActive = false;
    hideAllTitles();
    if (titleOnetime) titleOnetime.style.display = 'block';
    resetUnlock();
  }

  /* ---------- Events ---------- */
  subscribeLabel?.addEventListener('click', () => activateSubscribe());
  onetimeLabel?.addEventListener('click', activateOnetime);

  subscribeInput?.addEventListener('change', function () {
    if (this.checked) activateSubscribe();
  });

  onetimeInput?.addEventListener('change', function () {
    if (this.checked) activateOnetime();
  });

  options.forEach(option => {
    option.addEventListener('click', function () {
      if (giftWrapper) {
        if (this.classList.contains('single_option')) {
          giftWrapper.classList.add('one-pack');
        } else {
          giftWrapper.classList.remove('one-pack');
        }
      }

      if (isSubscribeActive) {
        showSubscribeMessage(this);
      }

      setTimeout(applyUnlock, 0);
    });
  });

  /* ---------- PAGE LOAD FIX (KEY CHANGE) ---------- */
  if (subscribeInput?.checked) {
    const firstSingleOption = document.querySelector('.single_option');
    activateSubscribe(firstSingleOption); // 👈 always show subscribe-two first
  } else if (onetimeInput?.checked) {
    activateOnetime();
  }
});



/*jQuery(document).on("click",".protein_kit_grid .protein_kit_label",function(){
totalPriceSet();
});

function totalPriceSet(){
    console.log("call total price");
  let priceTotal = 0;

  const giftProducts = document.querySelectorAll('.bundle-gift-wrapper .gift-product');

  giftProducts.forEach(product => {
    const priceEl = product.querySelector('.price');
    if (priceEl) {
      // Remove $ sign and convert to number
      console.log("price set");
      const price = parseFloat(priceEl.textContent.replace('$', '').trim());
      if (!isNaN(price)) {
        priceTotal += price;
      }
    }
  });

  // Update subscribe block title if it exists
  const subscribeTitle = document.querySelector('.bundle-gifts-block .block-title.block-title-subscribe');
  console.log("subscribeTitle",subscribeTitle);
  if (subscribeTitle) {
    subscribeTitle.textContent = '$' + priceTotal.toFixed(2); // format to 2 decimals
  }
}
*/
// THREE COLUMN LAYOUT BUNDLE -- END


// PRODUCT ACCORDION TAB -- START
document.addEventListener("DOMContentLoaded", function () {
  const accordionItemHeaders = document.querySelectorAll(
    ".product_accordion_header"
  );
  if (!accordionItemHeaders || accordionItemHeaders.length === 0) {
    return;
  }
  // First accordion
  const firstAccordionItemHeader = accordionItemHeaders[0];
  const firstAccordionItemBody =
    firstAccordionItemHeader.nextElementSibling;
  // Open the first accordion item by default
  // if (firstAccordionItemBody) {
  //   firstAccordionItemHeader.classList.add("active");
  //   firstAccordionItemBody.style.maxHeight =
  //     firstAccordionItemBody.scrollHeight + "px";
  // }
  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", () => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".product_accordion_header.active"
      );
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.remove("active");
        if (
          currentlyActiveAccordionItemHeader.nextElementSibling
        ) {
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody =
        accordionItemHeader.nextElementSibling;
      if (accordionItemBody) {
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      }
    });
  });
});
// PRODUCT ACCORDION TAB -- END

// PRODUCT SHORT DESCRIPTION -- START
$(document).ready(function () {
  $('.product_readmore_description').each(function () {
    const $wrapper = $(this);
    const fullHTML = $wrapper.html();
    const limit = 140;
    function truncateHTMLWithReadMore(html, limit) {
      let count = 0;
      const container = $('<div>').html(html);
      let lastTextNode = null;
      function walk(node) {
        if (count >= limit) {
          $(node).remove();
          return;
        }
        if (node.nodeType === 3) {
          if (count + node.nodeValue.length > limit) {
            node.nodeValue = node.nodeValue.substring(0, limit - count);
            count = limit;
          } else {
            count += node.nodeValue.length;
          }
          lastTextNode = node;
        } else if (node.nodeType === 1) {
          $(node).contents().each(function () {
            walk(this);
          });
        }
      }
      container.contents().each(function () {
        walk(this);
      });
      if (lastTextNode) {
        lastTextNode.nodeValue += '...';
        $(lastTextNode).after(
          '<span class="toggle-readmore"><strong>Read More</strong></span>'
        );
      }
      return container.html();
    }
    const truncatedHTML = truncateHTMLWithReadMore(fullHTML, limit);
    $wrapper.html(truncatedHTML);
    $wrapper.on('click', '.toggle-readmore', function () {
      if ($(this).text().includes('Read More')) {
        $wrapper.html(
          fullHTML +
            '<span class="toggle-readmore"><strong> Read Less</strong></span>'
        );
      } else {
        $wrapper.html(truncatedHTML);
      }
    });
  });
});
// PRODUCT SHORT DESCRIPTION -- END

// PRODUCT VIDEO POPUP -- START
jQuery(function($){
  var $popup = $('.hts-video-popup');
  var videoEl = document.getElementById('htsVideo');
  var $video = $('#htsVideo');
  var $source = $('#htsVideoSource');
  function stopPopupVideo(){
    if(videoEl){
      videoEl.pause();
      videoEl.currentTime = 0;

      // remove src so network stops
      $source.attr('src', '');
      videoEl.load();

      // remove poster
      $video.attr('poster', '');
    }
  }
  // CLICK THUMBNAIL
  $(document).on('click', '.pv_block_video', function(e){
    e.preventDefault();

    var url = $(this).attr('data-video-url');
    var poster = $(this).attr('data-video-poster') || '';

    if(!url){
      console.warn('No video URL found on clicked block.');
      return;
    }
    // Set poster first
    $video.attr('poster', poster);
    // Set source & reload
    $source.attr('src', url);
    videoEl.load();
    // Show popup
    $popup.addClass('active').attr('aria-hidden','false');
    // Try to play
    var playPromise = videoEl.play();
    if(playPromise !== undefined){
      playPromise.catch(function(err){
        console.log('Autoplay prevented:', err);
      });
    }
  });
  // CLOSE BUTTON 1
  $(document).on('click', '.hts-video-close', function(){
    $popup.removeClass('active').attr('aria-hidden','true');
    stopPopupVideo();
  });
  // CLOSE BUTTON 2 (YOUR REQUEST)
  $(document).on('click', '.hts-video-close-icon', function(){
    $popup.removeClass('active').attr('aria-hidden','true');
    stopPopupVideo();
  });
  // CLICK OUTSIDE VIDEO CLOSE
  $popup.on('click', function(e){
    if(e.target === this){
      $popup.removeClass('active').attr('aria-hidden','true');
      stopPopupVideo();
    }
  });
  // ESC KEY CLOSE
  $(document).on('keyup', function(e){
    if(e.key === 'Escape'){
      $popup.removeClass('active').attr('aria-hidden','true');
      stopPopupVideo();
    }
  });

  // OPTIONAL LOADING STATE
  if(videoEl!=null){
    videoEl.addEventListener('waiting', function(){
      $popup.addClass('loading');
    });

    videoEl.addEventListener('playing', function(){
      $popup.removeClass('loading');
    });
  }

});
// PRODUCT VIDEO POPUP -- END
